import { DatePipe, CurrencyPipe } from '@angular/common';
import { Component, OnInit, Renderer2, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { Config } from 'src/app/app-constant';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { HttpService } from 'src/app/service/http/http.service';
import { Subscription } from 'rxjs';
import { SharedService } from 'src/app/service/shared/shared.service';
import { MatStepper } from '@angular/material/stepper';
import { LoaderService } from 'src/app/service/loader/loader.service';
import { DetailsPopupComponent } from 'src/app/shared/popups/details-popup/details-popup.component';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { ReplaceEmployeePopupComponent } from 'src/app/shared/popups/replace-employee-popup/replace-employee-popup.component';
import { saveAs } from 'file-saver';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { DateAdapter } from '@angular/material/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DataRefreshService } from 'src/app/services/dataRefreshService.service';

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
}
@Component({
  selector: 'app-employee-master',
  templateUrl: './employee-master.component.html',
  styleUrls: ['./employee-master.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }, // Use en-GB to get DD/MM/YYYY format
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ],
})
export class EmployeeMasterComponent implements OnInit {
  gridData: {
    columnInfo: Array<{ label: string, propertyName: string, sortingName: string }>,
    columnData: Array<any>,
    totalCount: number,
    totalNoOfPages: number,
    showCheckBox: boolean
    showExportBtn: boolean,
    showGraphBtn: boolean
    showSearchBar: boolean,
    showAddBtn: boolean,
    currentPage: number,
    showDeleteBtn: boolean,
    tabsData: Array<any>,
    tabsMainData: Array<any>,
    showAccessConfigBtn: boolean,
    showTitle: boolean,
    showBreadCrumbs: boolean,
    showAuditLog: boolean,
    showPermantDeleteBtn: boolean,
    showRestoreBtn: boolean,
    showImportBtn: boolean,
    showBackBtn: boolean,
    showRefreshFunctinallity: boolean,
    countTabs: Array<any>,
  } = {
      columnInfo: [], columnData: [], totalCount: 0, totalNoOfPages: 0, showCheckBox: true, showExportBtn: true,
      showGraphBtn: false, showSearchBar: true, showAddBtn: true, currentPage: 0, showDeleteBtn: true,
      tabsData: [], tabsMainData: [], showAccessConfigBtn: false, showTitle: true, showBreadCrumbs: false,
      showAuditLog: false, showPermantDeleteBtn: false, showRestoreBtn: false, showImportBtn: true, showBackBtn: false,
      showRefreshFunctinallity: true, countTabs: []
    };
  isChangeDetected: boolean = false;
  paginationUrl: any = null;
  currentPage: number = 0;
  selectedSizeToShowData: number = 25;
  searchString: any = null;
  showAddPopup: boolean = false;
  showDetailsPopup: boolean = false;
  showListingPage: boolean = true;
  isEditModeactive: boolean = false;
  maxDate: any;
  currentDate: any;
  getUserId: any = 0;
  selectedTypeTabIndex: any = 0;
  selectedTypeTab: any = 'Active';
  incidentReportData: any = [];
  isLinear = false;
  private subscription!: Subscription;
  collapseSidebar: boolean = false;
  @ViewChild('stepper')
  stepper!: MatStepper;
  userForm: FormGroup = new FormGroup({});
  employeementRelatedUserForm: FormGroup = new FormGroup({});
  generalInformationUserForm: FormGroup = new FormGroup({});
  educationRelatedInformationUserForm: FormGroup = new FormGroup({});
  salaryRelatedInformationUserForm: FormGroup = new FormGroup({});
  priorEmploymentRelatedInformationUserForm: FormGroup = new FormGroup({});
  roleList = [
    { id: 1, name: 'Super Admin' },
    { id: 2, name: 'PHI Admin' },
    { id: 3, name: 'PHI Finance & Accounts' }
  ]
  employeeData: any = [];
  loggedInUserCompanyID: any;
  empCode: any;
  getAllEmployeeofCompany: any = [];
  loggedInUserCompanyName: any;
  empStatus: any = 1;
  subModuleButtonColor: any;
  buttonColorName: any;
  replacementNotAvailable: boolean = false;
  readOnlyFields: boolean = false;
  isFirstEmployee: boolean = false;
  isReplaceEmployeeFilled: boolean = false;
  employeeIdOfMD: any;
  getListOfGroupNameOfComp: any = [];
  getListOfCompanyNameOfComp: any = [];
  getListOfBandNameOfComp: any = [];
  getListOfGradeNameOfComp: any = [];
  getListOfDesignationsOfComp: any = [];
  getListOfDepartmentsOfComp: any = [];
  getListOfSubDepartmentsOfComp: any = [];
  getListOfDesignationsAtDOJOfComp: any = [];
  getListOfCurrentRatingOfComp: any = [];
  getListOfLastYearRatingOfComp: any = [];
  getListOfLastToLastYearRatingOfComp: any = [];
  getCountryList: any = []
  getListOfHighestQualificationOfComp: any = [];
  getCurrencyList: any = [];
  getBankNameList: any = [];
  customFieldObject: any = [];
  showErrorMsgOfExistUAN: boolean = false;
  showErrorMsgOfExistPAN: boolean = false;
  showErrorMsgOfExistAddharNo: boolean = false;
  showErrorMsgOfExistAccountNo: boolean = false;
  showErrorMsgOfExistEmail: boolean = false;
  showErrorMsgOfExistEmpCode: boolean = false;
  officialEmail: any;
  uan: any;
  panNo: any;
  bankAccount: any;
  aadharNo: any;
  isEmployeeRole:boolean=false;
  loggedInUserRole:any;
  constructor(private httpService: HttpService, private config: Config, public router: Router,
    private fb: FormBuilder, public dialog: MatDialog, private datePipe: DatePipe,
    private activatedroute: ActivatedRoute, private sharedService: SharedService,
    private renderer: Renderer2, private loader: LoaderService, private encryptionService: EncryptionService,
    private dataRefreshService: DataRefreshService,
    private currencyPipe: CurrencyPipe) { }

  ngOnInit() {
    this.loggedInUserCompanyName = sessionStorage.getItem('loggedInUserCompanyName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.initilaizeColumn();
    // this.initilaizeTabs()
    this.initilaizeUserForm();
    this.initilaizeEmployeeRelatedUserForm();
    this.initilaizeGeneralInformationUserForm();
    this.initilaizeEducationRelatedInformationUserForm();
    this.initilaizeSalaryRelatedInformationUserForm();
    this.initilaizePriorEmploymentRelatedInformationUserForm();

  }
  ionViewWillEnter() {
    this.loggedInUserCompanyName = sessionStorage.getItem('loggedInUserCompanyName');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.showAddPopup = false;
    this.showDetailsPopup = false;
    this.isEditModeactive = false;
    this.showListingPage = true;
    this.currentDate = (new Date()).toISOString();
    this.activatedroute.params.subscribe((params: any) => {
      if (params?.operation == 'Add') {
        this.showAddPopup = true;
        this.showDetailsPopup = false;
        this.isEditModeactive = false;
        this.showListingPage = false;
        this.initilaizeEmployeeRelatedUserForm();
        this.initilaizeGeneralInformationUserForm();
        this.initilaizeEducationRelatedInformationUserForm();
        this.initilaizeSalaryRelatedInformationUserForm();
        this.initilaizePriorEmploymentRelatedInformationUserForm();
        this.getAllUser();
        this.getAllCustomFieldsList();
        this.getAllEmployeeDropdownByCompanyID();
        this.getGroupNameByCompany();
        this.getCompanyNameByCompany();
        this.getBandsByCompany();
        this.getGradeByCompany();
        this.getDesignationsByCompany();
        this.getDepartmentsByCompany();
        this.getSubDepartmentByCompany();
        this.getDesignationsAtDOJByCompany();
        this.getCurrentRatingByCompany();
        this.getLastYearRatingByCompany();
        this.getLastToLastYearRatingByCompany();
        this.getAllCountryList();
        this.getHighestQualificationByCompany();
        this.getCurrencyByCompany();
        this.getBankNameByCompany();
        // this.maxDate = this.datePipe.transform(this.currentDate, "yyyy-MM-ddTHH:mm", 'IST')
        // const dateTimeInput = document.getElementById("datetimeInput") as HTMLInputElement;
        // dateTimeInput.max = new Date().toISOString().split("Z")[0];
      } else if (params?.operation == 'Edit') {
        this.getUserId = params?.id
        this.showAddPopup = true;
        this.showDetailsPopup = false;
        this.isEditModeactive = true;
        this.showListingPage = false;
        this.initilaizeEmployeeRelatedUserForm();
        this.initilaizeGeneralInformationUserForm();
        this.initilaizeEducationRelatedInformationUserForm();
        this.initilaizeSalaryRelatedInformationUserForm();
        this.initilaizePriorEmploymentRelatedInformationUserForm();
        this.getAllCustomFieldsList();
        this.getAllEmployeeDropdownByCompanyID();
        this.getGroupNameByCompany();
        this.getCompanyNameByCompany();
        this.getBandsByCompany();
        this.getGradeByCompany();
        this.getDesignationsByCompany();
        this.getDepartmentsByCompany();
        this.getSubDepartmentByCompany();
        this.getDesignationsAtDOJByCompany();
        this.getCurrentRatingByCompany();
        this.getLastYearRatingByCompany();
        this.getLastToLastYearRatingByCompany();
        this.getAllCountryList();
        this.getHighestQualificationByCompany();
        this.getCurrencyByCompany();
        this.getBankNameByCompany();
        this.getUserByID();
      } else if (params?.operation == 'Show') {
        this.getUserId = params?.id
        this.showAddPopup = false;
        this.showDetailsPopup = true;
        this.isEditModeactive = false;
        this.showListingPage = false;
        this.getUserByID();
      } else {
        if(this.loggedInUserRole == 'Admin'){
          this.gridData.showAddBtn=false;
          this.gridData.showImportBtn=false;
          this.gridData.showExportBtn=false;
          this.gridData.showCheckBox=false;
        }else{
          this.gridData.showExportBtn=true;
          this.gridData.showAddBtn=true;
          this.gridData.showImportBtn=true;
          this.gridData.showCheckBox=true;
        }
        this.showAddPopup = false;
        this.showDetailsPopup = false;
        this.isEditModeactive = false;
        this.showListingPage = true;
        // this.changeSubMenuBackgroundColor();
        this.getEmployeeCount();
        this.getAllUser();
      }
    })
  }
  private expandAndCollapseSidebar() {
    this.collapseSidebar = !this.collapseSidebar;
  }

  initilaizeColumn() {
    this.gridData.columnInfo = [];
    
    if (this.selectedTypeTab == 'Active') {
      this.gridData.columnInfo.push({ label: 'Emp ID', propertyName: 'linkName', sortingName: 'employeeId' });
      this.gridData.columnInfo.push({ label: 'First Name', propertyName: 'firstName', sortingName: 'firstName' });
      this.gridData.columnInfo.push({ label: 'Last Name', propertyName: 'lastName', sortingName: 'lastName' });
      this.gridData.columnInfo.push({ label: 'DOJ', propertyName: 'doj', sortingName: 'dateOfJoining' });
      this.gridData.columnInfo.push({ label: 'Designation', propertyName: 'designation', sortingName: 'designation' });
      this.gridData.columnInfo.push({ label: 'Department', propertyName: 'department', sortingName: 'department' });
      this.gridData.columnInfo.push({ label: 'Manager', propertyName: 'manager', sortingName: 'reportingManagerName' });
      this.gridData.columnInfo.push({ label: 'Status', propertyName: 'status', sortingName: 'status' });
      if(this.loggedInUserRole != 'Admin'){
        this.gridData.columnInfo.push({ label: 'Action', propertyName: 'action', sortingName: 'status' });
      }
    } else {
      this.gridData.columnInfo.push({ label: 'Emp ID', propertyName: 'linkName', sortingName: 'employeeId' });
      this.gridData.columnInfo.push({ label: 'First Name', propertyName: 'firstName', sortingName: 'firstName' });
      this.gridData.columnInfo.push({ label: 'Last Name', propertyName: 'lastName', sortingName: 'lastName' });
      this.gridData.columnInfo.push({ label: 'DOJ', propertyName: 'doj', sortingName: 'dateOfJoining' });
      this.gridData.columnInfo.push({ label: 'DOE', propertyName: 'lastWorkingDate', sortingName: 'lastWorkingDate' });
      this.gridData.columnInfo.push({ label: 'Designation', propertyName: 'designation', sortingName: 'designation' });
      this.gridData.columnInfo.push({ label: 'Department', propertyName: 'department', sortingName: 'department' });
      this.gridData.columnInfo.push({ label: 'Manager', propertyName: 'manager', sortingName: 'reportingManagerName' });
      this.gridData.columnInfo.push({ label: 'Status', propertyName: 'status', sortingName: 'status' });
      if(this.loggedInUserRole != 'Admin'){
        this.gridData.columnInfo.push({ label: 'Action', propertyName: 'action', sortingName: 'status' });
      }
    }
  }
  renderData(listData: any) {
    let cnt = this.gridData.currentPage * 25;
    this.gridData.columnData = [];
    if (this.selectedTypeTab == 'Active') {
      if(this.loggedInUserRole != 'Admin'){
        for (let i = 0; i < listData?.length; i++) {
          this.gridData.columnData.push({
            id: listData[i].id,
            linkName: listData[i].empCode,
            firstName: listData[i].firstName,
            lastName: listData[i].lastName,
            doj: this.datePipe.transform(listData[i].dateOfJoining, "dd-MM-yyyy"),
            designation: listData[i].designation,
            department: listData[i].department,
            manager: listData[i].reportingManagerName,
            status: listData[i]?.empStatus,
            action: 'edit'
          });
        }    
      }else{
        for (let i = 0; i < listData?.length; i++) {
          this.gridData.columnData.push({
            id: listData[i].id,
            linkName: listData[i].empCode,
            firstName: listData[i].firstName,
            lastName: listData[i].lastName,
            doj: this.datePipe.transform(listData[i].dateOfJoining, "dd-MM-yyyy"),
            designation: listData[i].designation,
            department: listData[i].department,
            manager: listData[i].reportingManagerName,
            status: listData[i]?.empStatus,
          });
        }  
      }
    } else {
      if(this.loggedInUserRole != 'Admin'){
        for (let i = 0; i < listData?.length; i++) {
          this.gridData.columnData.push({
            id: listData[i].id,
            linkName: listData[i].empCode,
            firstName: listData[i].firstName,
            lastName: listData[i].lastName,
            doj: this.datePipe.transform(listData[i].dateOfJoining, "dd-MM-yyyy"),
            lastWorkingDate: this.datePipe.transform(listData[i].lastWorkingDate, "dd-MM-yyyy"),
            designation: listData[i].designation,
            department: listData[i].department,
            manager: listData[i].reportingManagerName,
            status: listData[i]?.empStatus,
            action: 'edit'
          });
        } 
      }else{
        for (let i = 0; i < listData?.length; i++) {
          this.gridData.columnData.push({
            id: listData[i].id,
            linkName: listData[i].empCode,
            firstName: listData[i].firstName,
            lastName: listData[i].lastName,
            doj: this.datePipe.transform(listData[i].dateOfJoining, "dd-MM-yyyy"),
            lastWorkingDate: this.datePipe.transform(listData[i].lastWorkingDate, "dd-MM-yyyy"),
            designation: listData[i].designation,
            department: listData[i].department,
            manager: listData[i].reportingManagerName,
            status: listData[i]?.empStatus,
          });
        } 
      }
    }
    this.isChangeDetected = !this.isChangeDetected
  }
  initilaizeUserForm() {
    this.userForm = this.fb.group({
      aadharNo: ['', Validators.pattern(/^[0-9]{12}$/)],
      address: [''],
      annualCTC: ['', Validators.required],
      band: ['', Validators.required],
      compId: [this.loggedInUserCompanyID],
      companyName: [''],
      contactNo: ['', [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
      dateOfBirth: [''],
      dateOfJoining: ['', Validators.required],
      dateOfResignation: [null],
      department: ['', Validators.required],
      designation: ['', Validators.required],
      dottedReportingManagerCode: [''],
      dottedReportingManagerName: [null],
      emergencyContactNo: ['', Validators.pattern(/^[0-9]{10}$/)],
      empCode: ['', Validators.required],
      empStatus: ['Active', Validators.required],
      firstName: ['', [Validators.required]],
      function: ['', Validators.required],
      gender: ['Male', Validators.required],
      grade: ['', Validators.required],
      hodCode: [''],
      hodName: [null],
      id: [null],
      isVacant: [false],
      lastName: ['', [Validators.required]],
      lastWorkingDate: [null],
      maritalStatus: [null],
      monthlyCTC: ['', Validators.required],
      officeLocation: ['', Validators.required],
      officialEmail: ['', [Validators.required, Validators.pattern(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/)]],
      personalEmail: [null, Validators.pattern(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/)],
      qualification: [''],
      replacementId: [null],
      reportingManagerCode: [''],
      reportingManagerName: [null],
      totalExperience: [null],
      uan: ['', Validators.pattern(/^[0-9]{12}$/)],
      temporaryEmpId: [null],
      isReplacement: [true],
    });
  }
  initilaizeEmployeeRelatedUserForm() {
    this.employeementRelatedUserForm = this.fb.group({
      empCode: [null, Validators.required],
      employmentCategory: [null, Validators.required],
      employmentType: [null, Validators.required],
      retirementAge: [null],
      empStatus: ['Active', Validators.required],
      dateOfJoining: [null, Validators.required],
      dateOfResignation: [null, Validators.required],
      lastWorkingDate: [null, Validators.required],
      groupName: [null, Validators.required],
      companyName: [null, Validators.required],
      officialEmail: [null, [Validators.required, Validators.pattern(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/)]],
      reportingManagerName: [null, Validators.required],
      reportingManagerCode: [null, Validators.required],
      dottedReportingManagerName: [null],
      dottedReportingManagerCode: [null],
      hodName: [null, Validators.required],
      hodCode: [null, Validators.required],
      band: [null, Validators.required],
      grade: [null, Validators.required],
      designation: [null, Validators.required],
      department: [null, Validators.required],
      subDepartment: [null],
      workLocationState: [null,Validators.required],
      workLocationCity: [null,Validators.required],
      catalystRole: [null],
      designationAtDoj: [null,Validators.required],
      noOfPromotions: [null],
      currentPerformanceScore: [null],
      currentPerformanceRating: [null],
      lastYearPerformanceScore: [null],
      lastYearPerformanceRating: [null],
      yearBeforeLastYearPerformanceScore: [null],
      yearBeforeLastYearPerformanceRating: [null],
      temporaryEmpId: [null],
      isVacant: [false]
    });
  }
  initilaizeGeneralInformationUserForm() {
    this.generalInformationUserForm = this.fb.group({
      salutation: [null, Validators.required],
      firstName: [null, [Validators.required]],
      lastName: [null, [Validators.required]],
      gender: [null, Validators.required],
      country: ['India', Validators.required],
      address: [null, Validators.required],
      permanentAddress: [null],
      maritalStatus: [null],
      dateOfMarriage: [null],
      dateOfBirth: [null, Validators.required],
      age: [null],
      personalEmail: [null],
      aadharNo: [null, [Validators.required, Validators.pattern(/^[0-9]{12}$/)]],
      panNo: [null, [Validators.required, Validators.pattern(/^[A-Za-z0-9]{10}$/)]],
      uan: [null, Validators.pattern(/^[0-9]{12}$/)],
      contactNo: [null, [Validators.required, Validators.pattern(/^[0-9]{10}$/)]],
      totalExperience: [null],
      emergencyContactNo: [null],
      bloodGroup: [null],
      fathersName: [null],
      mothersName: [null],
      spouseName: [null],
      noOfChildren: [null],
      isRelativeWorking: [false],
      workingRelativeName: [null],
      workingRelativeRelation: [null],
      id: [null],
      isReplacement: [true],
      replacementId: [null],
    });
  }
  initilaizeEducationRelatedInformationUserForm() {
    this.educationRelatedInformationUserForm = this.fb.group({
      highestEducationQualification: [null],
      highestEducationInstitute: [null],
      highestEducationYearOfPassing: [null],
      highestEducationMarks: [null],
      highestEducationQualification2: [null],
      highestEducationInstitute2: [null],
      highestEducationYearOfPassing2: [null],
      highestEducationMarks2: [null],
      highestEducationQualification3: [null],
      highestEducationInstitute3: [null],
      highestEducationYearOfPassing3: [null],
      highestEducationMarks3: [null],
      highestProfessionalQualification: [null],
      highestProfessionalInstitute: [null],
      highestProfessionalYearOfPassing: [null],
      highestProfessionalMarks: [null],
    });
  }
  initilaizeSalaryRelatedInformationUserForm() {
    this.salaryRelatedInformationUserForm = this.fb.group({
      currency: ['INR'],
      salaryStatus: [null, Validators.required],
      bankName: [null, Validators.required],
      bankBranchAddress: [null, Validators.required],
      bankAccount: [null, Validators.required],
      ifscCode: [null, Validators.required],
      basicSalaryPm: [null, Validators.required],
      daPm: [null],
      hraPm: [null,],
      otherAllowancePm: [null,],
      ltaPm: [null,],
      medicalAllowancePm: [null,],
      washingAllowancePm: [null,],
      specialAllowancePm: [null,],
      fuelAllowancePm: [null,],
      entertainmentAllowancePm: [null,],
      educationAllowancePm: [null,],
      booksAllowancePm: [null,],
      statutoryBonusPm: [null,],
      anyOtherAllowancePm: [null,],
      grossSalaryPm: [null, Validators.required],
      employeePfPm: [null,],
      employerPfPm: [null],
      ptPm: [null],
      lwfPm: [null],
      esicPm: [null],
      otherRetiralPm: [null],
      totalRetiralPm: [null, Validators.required],
      monthlyCTC: [null, Validators.required],
      annualCTC: [null, Validators.required],
      processOfVp: [null, Validators.required],
      annualVariablePayBudget: [null],
      annualTotalCtc: [null, Validators.required],
      incrementOn: [null, Validators.required],
    });
  }
  initilaizePriorEmploymentRelatedInformationUserForm() {
    this.priorEmploymentRelatedInformationUserForm = this.fb.group({
      lastOrganisationName: [null],
      lastOrganisationDoj: [null],
      lastOrganisationLwd: [null],
      lastOrganisationDepartment: [null],
      lastOrganisationDesignation: [null],
      lastToLastOrganisationName: [null],
      lastToLastOrganisationDoj: [null],
      lastToLastOrganisationLwd: [null],
      lastToLastOrganisationDepartment: [null],
      lastToLastOrganisationDesignation: [null],
      otherOrganisationName: [null],
      otherOrganisationDoj: [null],
      otherOrganisationLwd: [null],
      otherOrganisationDepartment: [null],
      otherOrganisationDesignation: [null],
    });
  }
  initilaizeTabs() {
    this.gridData.tabsData = [];
    // for (let i = 0; i < data?.length; i++) {
    this.gridData.tabsData = [
      { label: 'Active', totalCount: 0, icons: 'person' },
      { label: 'Exited', totalCount: 0, icons: 'person_off' },
    ]
    // }
  }
  typeTabChnage(data: any) {
    const parts = data?.tab?.textLabel?.split(' (');
    this.selectedTypeTabIndex = data?.index;
    if (this.selectedTypeTabIndex == 1) {
      this.selectedTypeTab = 'Exited';
      this.empStatus = 0;
      this.gridData.showAddBtn=false;
      this.gridData.showImportBtn=false;
    } else {
      this.selectedTypeTab = 'Active';
      this.empStatus = 1;
      if(this.loggedInUserRole == 'Admin'){
        this.gridData.showAddBtn=false;
        this.gridData.showImportBtn=false;
        this.gridData.showExportBtn=false;
        this.gridData.showCheckBox=false;
      }else{
        this.gridData.showExportBtn=true;
        this.gridData.showAddBtn=true;
        this.gridData.showImportBtn=true;
        this.gridData.showCheckBox=true;
      }
    }
    this.initilaizeColumn();
    this.getAllUser();
    // this.removeSubMenuPreviousActiveTabClass();
    // this.changeSubMenuBackgroundColor();
  }
  deleteMultipleRecord(deleteData: any) {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: 'Do you really want to delete these record?',
        btn1: 'Cancel',
        btn2: 'Delete',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        let id: any[] = [];
        for (let i = 0; i < deleteData.length; i++) {
          id.push(deleteData[i].find((item: any) => item.key == 'id').value)
        }
        this.loader.simpleLoaderWithDuration();
        this.httpService.callPostService(this.config.softDeleteEmployees, { isDeleted: true, id: id })
          .subscribe((res: any) => {
            this.loader.dismissLoader();
            const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: '30%',
              data: {
                msg: res.data,
                btn2: 'OK',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: true,
                showSuccessMessage: false,
                showCloseIcon: false
              },
            });
            successdialogRef.afterClosed().subscribe(result => {
              this.getEmployeeCount();
              this.getAllUser();
            });
          }, (err: any) => {
            this.loader.dismissLoader();
            console.log(err)
          });
      }
    });
  }
  pageNavigation(response: any) {
    this.currentPage = response.currentPageNumber - 1;
    this.renderData(response.data.plant);
  }
  backBtn() {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: 'Are you sure you want to leave this page?',
        btn1: 'Cancel',
        btn2: 'Yes',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.router.navigate(['/home/hrportal/employeemaster']);
      }
    });
  }
  backbtnWithoutConfirmation() {
    this.router.navigate(['/home/hrportal/employeemaster']);
  }
  addEditBackButton() {
    if (this.isEditModeactive) {
      this.backbtnWithoutConfirmation();
    } else {
      this.backBtn()
    }
  }
  addRecord() {
    this.router.navigate(['/home/hrportal/employeemaster', { id: 0, operation: 'Add' }]);
  }
  editRecord(data: any) {
    let id = data.find((item: any) => item.key == 'id').value;
    this.router.navigate(['/home/hrportal/employeemaster', { id: id, operation: 'Edit' }]);
  }
  sortAsending(data: any) {
    const request = {
      "search": this.searchString,
      "userType": null,
      "status": this.empStatus,
      "companyId": this.loggedInUserCompanyID,
      "loggedInUserRole": this.loggedInUserRole,
    }
    this.httpService.callPostService(this.config.searchEmployeeMaster + '?page=' + 0 + '&size=' + this.selectedSizeToShowData + '&sort=' + data?.sortingName + ',asc', request)
      .subscribe((data: any) => {
        this.currentPage = 0;
        this.gridData.totalNoOfPages = data.data?.totalPages;
        this.gridData.totalCount = data.data?.total;
        this.gridData.currentPage = data.data?.currentPageNumber;
        this.renderData(data.data?.users);
      }, (error: any) => {
      }, () => { });
  }
  sortDesending(data: any) {
    const request = {
      "search": this.searchString,
      "userType": null,
      "status": this.empStatus,
      "companyId": this.loggedInUserCompanyID,
      "loggedInUserRole": this.loggedInUserRole,
    }
    this.httpService.callPostService(this.config.searchEmployeeMaster + '?page=' + 0 + '&size=' + this.selectedSizeToShowData + '&sort=' + data?.sortingName + ',desc', request)
      .subscribe((data: any) => {
        this.currentPage = 0;
        this.gridData.totalNoOfPages = data.data?.totalPages;
        this.gridData.totalCount = data.data?.total;
        this.gridData.currentPage = data.data?.currentPageNumber;
        this.renderData(data.data?.users);
      }, (error: any) => {
      }, () => { });
  }
  pageChange(data: any) {
    const request = {
      "search": this.searchString,
      "userType": null,
      "status": this.empStatus,
      "companyId": this.loggedInUserCompanyID,
      "loggedInUserRole": this.loggedInUserRole,
    }
    this.httpService.callPostService(this.config.searchEmployeeMaster + '?page=' + data + '&size=' + this.selectedSizeToShowData, request)
      .subscribe((data: any) => {
        this.currentPage = 0;
        this.gridData.totalNoOfPages = data.data?.totalPages;
        this.gridData.totalCount = data.data?.total;
        this.gridData.currentPage = data.data?.currentPageNumber;
        this.renderData(data.data?.users);
      }, (error: any) => {
      }, () => { });
  }
  onSelectSizeData(size: any) {
    this.selectedSizeToShowData = size;
    const request = {
      "search": this.searchString,
      "userType": null,
      "status": this.empStatus,
      "companyId": this.loggedInUserCompanyID,
      "loggedInUserRole": this.loggedInUserRole,
    }
    this.httpService.callPostService(this.config.searchEmployeeMaster + '?page=' + 0 + '&size=' + this.selectedSizeToShowData, request)
      .subscribe((data: any) => {
        this.currentPage = 0;
        this.gridData.totalNoOfPages = data.data?.totalPages;
        this.gridData.totalCount = data.data?.total;
        this.gridData.currentPage = data.data?.currentPageNumber;
        this.renderData(data.data?.users);
      }, (error: any) => {
      }, () => { });
  }
  searchData(data: any) {
    var search = ''
    this.searchString = data;
    if (data == '') {
      this.searchString = null;
      this.getAllUser();
      return;
    }
    if (data.length > 1) {
      setTimeout(() => {
        search = data;
        if (search.length == data.length) {
          setTimeout(() => {
            const request = {
              "search": this.searchString,
              "userType": null,
              "status": this.empStatus,
              "companyId": this.loggedInUserCompanyID,
              "loggedInUserRole": this.loggedInUserRole,
            }
            this.httpService.callPostService(this.config.searchEmployeeMaster + '?page=' + 0 + '&size=' + this.selectedSizeToShowData, request)
              .subscribe((data: any) => {
                this.currentPage = 0;
                this.gridData.totalNoOfPages = data.data?.totalPages;
                this.gridData.totalCount = data.data?.total;
                this.gridData.currentPage = data.data?.currentPageNumber;
                this.renderData(data.data?.users);
              }, (error: any) => {
              }, () => { });
          },
            500);
        }
      },
        1500);
    }
  }
  refreshData() {
    this.searchString = null;
    this.gridData.currentPage = 0;
    this.selectedSizeToShowData = 25;
    this.currentPage = 0;
    this.getEmployeeCount();
    this.getAllUser();
  }
  exportReport(selectedIds: any) {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "fromYear": null,
      "search": this.selectedTypeTab,
      "toYear": null,
      "loggedInUserRole": this.loggedInUserRole
    }
    this.httpService.callPostService(this.config.employeesDownloadByStatus, request)
      .subscribe((data: any) => {
        saveAs(data?.fileUrl, 'EmployeesData')
      }, (error: any) => {
      }, () => { });
  }
  showDatails(data: any) {
    let id = data.find((item: any) => item.key == 'id').value;
    this.router.navigate(['/home/hrportal/employeemaster', { id: id, operation: 'Show' }]);
  }
  deleteRecords(deleteData: any) {
    const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
      disableClose: true,
      height: '25%',
      width: '30%',
      data: {
        msg: 'Do you really want to delete this record?',
        btn1: 'Cancel',
        btn2: 'Delete',
        btn2BgColor: this.buttonColorName,
        showSuccessIcon: false,
        showSuccessMessage: false,
        showCloseIcon: false
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        let id: any[] = [];
        id.push(deleteData.find((item: any) => item.key == 'id').value);
        this.loader.simpleLoaderWithDuration();
        this.httpService.callPostService(this.config.softDeleteEmployees, { isDeleted: true, id: id })
          .subscribe((res: any) => {
            this.loader.dismissLoader();
            const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: '30%',
              data: {
                msg: res.data,
                btn2: 'OK',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: true,
                showSuccessMessage: false,
                showCloseIcon: false
              },
            });
            successdialogRef.afterClosed().subscribe(result => {
              this.getEmployeeCount();
              this.getAllUser();
            });
          }, (err: any) => {
            this.loader.dismissLoader();
            console.log(err)
          });
      }
    });
  }
  getAllUser() {
    const request = {
      "search": this.searchString,
      "userType": null,
      "status": this.empStatus,
      "companyId": this.loggedInUserCompanyID,
      "loggedInUserRole": this.loggedInUserRole,
    }
    this.loader.simpleLoaderWithDuration();
    this.httpService.callPostService(this.config.searchEmployeeMaster + '?page=' + 0 + '&size=' + this.selectedSizeToShowData, request)
      .subscribe((data: any) => {
        this.loader.dismissLoader();
        this.currentPage = 0;
        this.gridData.totalNoOfPages = data.data?.totalPages;
        this.gridData.totalCount = data.data?.total;
        this.gridData.currentPage = data.data?.currentPageNumber;
        this.renderData(data.data?.users);
      }, (error: any) => {
        this.loader.dismissLoader();
      }, () => { });
  }
  isChecked = false;
  addSubmitForm: boolean = false;
  onClickAddUser() {
    var flag = true;
    this.addSubmitForm = true;
    this.employeementRelatedUserForm.markAllAsTouched();
    this.generalInformationUserForm.markAllAsTouched();
    this.educationRelatedInformationUserForm.markAllAsTouched();
    this.salaryRelatedInformationUserForm.markAllAsTouched();
    this.priorEmploymentRelatedInformationUserForm.markAllAsTouched();

    if (this.employeementRelatedUserForm.value.groupName?.label) {
      this.employeementRelatedUserForm.controls['groupName'].setValue(this.employeementRelatedUserForm.value.groupName?.label);
    }
    if (this.employeementRelatedUserForm.value.companyName?.label) {
      this.employeementRelatedUserForm.controls['companyName'].setValue(this.employeementRelatedUserForm.value.companyName?.label);
    }
    if (this.employeementRelatedUserForm.value.band?.label) {
      this.employeementRelatedUserForm.controls['band'].setValue(this.employeementRelatedUserForm.value.band?.label);
    }
    if (this.employeementRelatedUserForm.value.grade?.label) {
      this.employeementRelatedUserForm.controls['grade'].setValue(this.employeementRelatedUserForm.value.grade?.label);
    }
    if (this.employeementRelatedUserForm.value.designation?.label) {
      this.employeementRelatedUserForm.controls['designation'].setValue(this.employeementRelatedUserForm.value.designation?.label);
    }
    if (this.employeementRelatedUserForm.value.department?.label) {
      this.employeementRelatedUserForm.controls['department'].setValue(this.employeementRelatedUserForm.value.department?.label);
    }
    if (this.employeementRelatedUserForm.value.subDepartment?.label) {
      this.employeementRelatedUserForm.controls['subDepartment'].setValue(this.employeementRelatedUserForm.value.subDepartment?.label);
    }
    if (this.employeementRelatedUserForm.value.designationAtDoj?.label) {
      this.employeementRelatedUserForm.controls['designationAtDoj'].setValue(this.employeementRelatedUserForm.value.designationAtDoj?.label);
    }
    if (this.employeementRelatedUserForm.value.currentPerformanceRating?.label) {
      this.employeementRelatedUserForm.controls['currentPerformanceRating'].setValue(this.employeementRelatedUserForm.value.currentPerformanceRating?.label);
    }
    if (this.employeementRelatedUserForm.value.lastYearPerformanceRating?.label) {
      this.employeementRelatedUserForm.controls['lastYearPerformanceRating'].setValue(this.employeementRelatedUserForm.value.lastYearPerformanceRating?.label);
    }
    if (this.employeementRelatedUserForm.value.yearBeforeLastYearPerformanceRating?.label) {
      this.employeementRelatedUserForm.controls['yearBeforeLastYearPerformanceRating'].setValue(this.employeementRelatedUserForm.value.yearBeforeLastYearPerformanceRating?.label);
    }
    if (this.educationRelatedInformationUserForm.value.highestEducationQualification?.label) {
      this.educationRelatedInformationUserForm.controls['highestEducationQualification'].setValue(this.educationRelatedInformationUserForm.value.highestEducationQualification?.label);
    }
    if (this.salaryRelatedInformationUserForm.value.currency?.label) {
      this.salaryRelatedInformationUserForm.controls['currency'].setValue(this.salaryRelatedInformationUserForm.value.currency?.label);
    }
    if (this.salaryRelatedInformationUserForm.value.bankName?.label) {
      this.salaryRelatedInformationUserForm.controls['bankName'].setValue(this.salaryRelatedInformationUserForm.value.bankName?.label);
    }
    this.employeementRelatedUserForm.controls['officialEmail'].setValue(this.employeementRelatedUserForm.value.officialEmail?.trim());
    this.generalInformationUserForm.controls['personalEmail'].setValue(this.generalInformationUserForm.value.personalEmail?.trim());
    this.generalInformationUserForm.controls['firstName'].setValue(this.generalInformationUserForm.value.firstName?.trim());
    this.generalInformationUserForm.controls['lastName'].setValue(this.generalInformationUserForm.value.lastName?.trim());
    this.generalInformationUserForm.controls['address'].setValue(this.generalInformationUserForm.value.address?.trim());
    this.employeementRelatedUserForm.controls['companyName'].setValue(this.employeementRelatedUserForm.value.companyName?.trim());
    this.employeementRelatedUserForm.controls['grade'].setValue(this.employeementRelatedUserForm.value.grade?.trim());
    this.employeementRelatedUserForm.controls['designation'].setValue(this.employeementRelatedUserForm.value.designation?.trim());
    this.employeementRelatedUserForm.controls['department'].setValue(this.employeementRelatedUserForm.value.department?.trim());
    this.employeementRelatedUserForm.controls['workLocationCity'].setValue(this.employeementRelatedUserForm.value.workLocationCity?.trim());
    if (this.isFirstEmployee) {
      this.employeementRelatedUserForm.controls['employmentCategory'].clearValidators();
      this.employeementRelatedUserForm.controls['employmentType'].clearValidators();
      this.employeementRelatedUserForm.controls['dateOfJoining'].clearValidators();
      this.employeementRelatedUserForm.controls['groupName'].clearValidators();
      this.employeementRelatedUserForm.controls['companyName'].clearValidators();
      this.employeementRelatedUserForm.controls['reportingManagerName'].clearValidators();
      this.employeementRelatedUserForm.controls['reportingManagerCode'].clearValidators();
      this.employeementRelatedUserForm.controls['hodName'].clearValidators();
      this.employeementRelatedUserForm.controls['hodCode'].clearValidators();
      this.employeementRelatedUserForm.controls['band'].clearValidators();
      this.employeementRelatedUserForm.controls['grade'].clearValidators();
      this.employeementRelatedUserForm.controls['designation'].clearValidators();
      this.employeementRelatedUserForm.controls['department'].clearValidators();
      this.employeementRelatedUserForm.controls['workLocationState'].clearValidators();
      this.employeementRelatedUserForm.controls['workLocationCity'].clearValidators();
      this.employeementRelatedUserForm.controls['designationAtDoj'].clearValidators();
      this.generalInformationUserForm.controls['salutation'].clearValidators();
      this.generalInformationUserForm.controls['gender'].clearValidators();
      this.generalInformationUserForm.controls['country'].clearValidators();
      this.generalInformationUserForm.controls['address'].clearValidators();
      this.generalInformationUserForm.controls['dateOfBirth'].clearValidators();
      this.generalInformationUserForm.controls['aadharNo'].clearValidators();
      this.generalInformationUserForm.controls['panNo'].clearValidators();
      this.generalInformationUserForm.controls['uan'].clearValidators();
      this.generalInformationUserForm.controls['contactNo'].clearValidators();
      this.salaryRelatedInformationUserForm.controls['salaryStatus'].clearValidators();
      this.salaryRelatedInformationUserForm.controls['bankName'].clearValidators();
      this.salaryRelatedInformationUserForm.controls['bankBranchAddress'].clearValidators();
      this.salaryRelatedInformationUserForm.controls['bankAccount'].clearValidators();
      this.salaryRelatedInformationUserForm.controls['ifscCode'].clearValidators();
      this.salaryRelatedInformationUserForm.controls['basicSalaryPm'].clearValidators();
      this.salaryRelatedInformationUserForm.controls['grossSalaryPm'].clearValidators();
      this.salaryRelatedInformationUserForm.controls['totalRetiralPm'].clearValidators();
      this.salaryRelatedInformationUserForm.controls['monthlyCTC'].clearValidators();
      this.salaryRelatedInformationUserForm.controls['annualCTC'].clearValidators();
      this.salaryRelatedInformationUserForm.controls['processOfVp'].clearValidators();
      this.salaryRelatedInformationUserForm.controls['annualTotalCtc'].clearValidators();
      this.salaryRelatedInformationUserForm.controls['incrementOn'].clearValidators();
    }
    if (this.employeementRelatedUserForm.value.empStatus == 'Exited') {
      this.employeementRelatedUserForm.controls['lastWorkingDate'].setValidators([Validators.required]);
      this.employeementRelatedUserForm.controls['dateOfResignation'].setValidators([Validators.required]);
      this.employeementRelatedUserForm.controls['isVacant'].setValidators([Validators.required]);
    } else {
      this.employeementRelatedUserForm.controls['lastWorkingDate'].setValue(null);
      this.employeementRelatedUserForm.controls['dateOfResignation'].setValue(null);
      this.employeementRelatedUserForm.controls['lastWorkingDate'].clearValidators();
      this.employeementRelatedUserForm.controls['dateOfResignation'].clearValidators();
      this.employeementRelatedUserForm.controls['isVacant'].clearValidators();
    }
    this.employeementRelatedUserForm.controls['lastWorkingDate'].updateValueAndValidity();
    this.employeementRelatedUserForm.controls['dateOfResignation'].updateValueAndValidity();
    this.employeementRelatedUserForm.controls['employmentCategory'].updateValueAndValidity();
    this.employeementRelatedUserForm.controls['employmentType'].updateValueAndValidity();
    this.employeementRelatedUserForm.controls['dateOfJoining'].updateValueAndValidity();
    this.employeementRelatedUserForm.controls['groupName'].updateValueAndValidity();
    this.employeementRelatedUserForm.controls['companyName'].updateValueAndValidity();
    this.employeementRelatedUserForm.controls['reportingManagerName'].updateValueAndValidity();
    this.employeementRelatedUserForm.controls['reportingManagerCode'].updateValueAndValidity();
    this.employeementRelatedUserForm.controls['hodName'].updateValueAndValidity();
    this.employeementRelatedUserForm.controls['hodCode'].updateValueAndValidity();
    this.employeementRelatedUserForm.controls['band'].updateValueAndValidity();
    this.employeementRelatedUserForm.controls['grade'].updateValueAndValidity();
    this.employeementRelatedUserForm.controls['designation'].updateValueAndValidity();
    this.employeementRelatedUserForm.controls['department'].updateValueAndValidity();
    this.employeementRelatedUserForm.controls['workLocationState'].updateValueAndValidity();
    this.employeementRelatedUserForm.controls['workLocationCity'].updateValueAndValidity();
    this.employeementRelatedUserForm.controls['designationAtDoj'].updateValueAndValidity();
    this.generalInformationUserForm.controls['salutation'].updateValueAndValidity();
    this.generalInformationUserForm.controls['gender'].updateValueAndValidity();
    this.generalInformationUserForm.controls['country'].updateValueAndValidity();
    this.generalInformationUserForm.controls['address'].updateValueAndValidity();
    this.generalInformationUserForm.controls['dateOfBirth'].updateValueAndValidity();
    this.generalInformationUserForm.controls['aadharNo'].updateValueAndValidity();
    this.generalInformationUserForm.controls['panNo'].updateValueAndValidity();
    this.generalInformationUserForm.controls['uan'].updateValueAndValidity();
    this.generalInformationUserForm.controls['contactNo'].updateValueAndValidity();
    this.salaryRelatedInformationUserForm.controls['salaryStatus'].updateValueAndValidity();
    this.salaryRelatedInformationUserForm.controls['bankName'].updateValueAndValidity();
    this.salaryRelatedInformationUserForm.controls['bankBranchAddress'].updateValueAndValidity();
    this.salaryRelatedInformationUserForm.controls['bankAccount'].updateValueAndValidity();
    this.salaryRelatedInformationUserForm.controls['ifscCode'].updateValueAndValidity();
    this.salaryRelatedInformationUserForm.controls['basicSalaryPm'].updateValueAndValidity();
    this.salaryRelatedInformationUserForm.controls['grossSalaryPm'].updateValueAndValidity();
    this.salaryRelatedInformationUserForm.controls['totalRetiralPm'].updateValueAndValidity();
    this.salaryRelatedInformationUserForm.controls['monthlyCTC'].updateValueAndValidity();
    this.salaryRelatedInformationUserForm.controls['annualCTC'].updateValueAndValidity();
    this.salaryRelatedInformationUserForm.controls['processOfVp'].updateValueAndValidity();
    this.salaryRelatedInformationUserForm.controls['annualTotalCtc'].updateValueAndValidity();
    this.salaryRelatedInformationUserForm.controls['incrementOn'].updateValueAndValidity();
    
    if (this.employeementRelatedUserForm.value.empStatus == 'Exited' && this.replacementNotAvailable && !this.isEmployeeRole) {
      this.employeementRelatedUserForm.controls['temporaryEmpId'].setValidators([Validators.required]);
    } else {
      if (this.employeementRelatedUserForm.value.empStatus == 'Exited' && (!this.replacementNotAvailable || this.generalInformationUserForm.value.replacementId != null)) {
        if (this.isReplaceEmployeeFilled || this.generalInformationUserForm.value.replacementId != null) {
          flag = true;
        } else {
          flag = false
        }
      }
      this.employeementRelatedUserForm.controls['temporaryEmpId'].clearValidators();
    }
    this.employeementRelatedUserForm.controls['temporaryEmpId'].updateValueAndValidity();

    if (this.employeementRelatedUserForm.valid && this.generalInformationUserForm.valid &&
      this.educationRelatedInformationUserForm.valid && this.salaryRelatedInformationUserForm.valid &&
      this.priorEmploymentRelatedInformationUserForm.valid && !this.showErrorMsgOfExistUAN &&
      !this.showErrorMsgOfExistPAN && !this.showErrorMsgOfExistAddharNo && !this.showErrorMsgOfExistAccountNo &&
      !this.showErrorMsgOfExistEmail && !this.showErrorMsgOfExistEmpCode && flag) {
      this.addSubmitForm = false;
      const request = {
        aadharNo: this.generalInformationUserForm.value.aadharNo,
        address: this.generalInformationUserForm.value.address,
        age: this.generalInformationUserForm.value.age,
        annualCTC: this.salaryRelatedInformationUserForm.value.annualCTC,
        annualTotalCtc: this.salaryRelatedInformationUserForm.value.annualTotalCtc,
        annualVariablePayBudget: this.salaryRelatedInformationUserForm.value.annualVariablePayBudget,
        anyOtherAllowancePm: this.salaryRelatedInformationUserForm.value.anyOtherAllowancePm,
        band: this.employeementRelatedUserForm.value.band,
        bankAccount: this.salaryRelatedInformationUserForm.value.bankAccount,
        bankBranchAddress: this.salaryRelatedInformationUserForm.value.bankBranchAddress,
        bankName: this.salaryRelatedInformationUserForm.value.bankName,
        basicSalaryPm: this.salaryRelatedInformationUserForm.value.basicSalaryPm,
        bloodGroup: this.generalInformationUserForm.value.bloodGroup,
        booksAllowancePm: this.salaryRelatedInformationUserForm.value.booksAllowancePm,
        catalystRole: this.employeementRelatedUserForm.value.catalystRole,
        compId: this.loggedInUserCompanyID,
        companyName: this.employeementRelatedUserForm.value.companyName,
        contactNo: this.generalInformationUserForm.value.contactNo,
        country: this.generalInformationUserForm.value.country,
        currency: this.salaryRelatedInformationUserForm.value.currency,
        currentPerformanceRating: this.employeementRelatedUserForm.value.currentPerformanceRating,
        currentPerformanceScore: this.employeementRelatedUserForm.value.currentPerformanceScore,
        customValues: this.customFieldObject,
        daPm: this.salaryRelatedInformationUserForm.value.daPm,
        dateOfBirth: this.datePipe.transform(this.generalInformationUserForm.value.dateOfBirth, "yyyy-MM-dd"),
        dateOfJoining: this.datePipe.transform(this.employeementRelatedUserForm.value.dateOfJoining, "yyyy-MM-dd"),
        dateOfMarriage: this.datePipe.transform(this.generalInformationUserForm.value.dateOfMarriage, "yyyy-MM-dd"),
        dateOfResignation: this.datePipe.transform(this.employeementRelatedUserForm.value.dateOfResignation, "yyyy-MM-dd"),
        department: this.employeementRelatedUserForm.value.department,
        designation: this.employeementRelatedUserForm.value.designation,
        designationAtDoj: this.employeementRelatedUserForm.value.designationAtDoj,
        dottedReportingManagerCode: this.employeementRelatedUserForm.value.dottedReportingManagerCode,
        dottedReportingManagerName: this.employeementRelatedUserForm.value.dottedReportingManagerName,
        educationAllowancePm: this.salaryRelatedInformationUserForm.value.educationAllowancePm,
        emergencyContactNo: this.generalInformationUserForm.value.emergencyContactNo,
        empCode: this.employeementRelatedUserForm.value.empCode,
        empStatus: this.employeementRelatedUserForm.value.empStatus,
        employeePfPm: this.salaryRelatedInformationUserForm.value.employeePfPm,
        employerPfPm: this.salaryRelatedInformationUserForm.value.employerPfPm,
        employmentCategory: this.employeementRelatedUserForm.value.employmentCategory,
        employmentType: this.employeementRelatedUserForm.value.employmentType,
        entertainmentAllowancePm: this.salaryRelatedInformationUserForm.value.entertainmentAllowancePm,
        esicPm: this.salaryRelatedInformationUserForm.value.esicPm,
        fathersName: this.generalInformationUserForm.value.fathersName,
        firstName: this.generalInformationUserForm.value.firstName,
        fuelAllowancePm: this.salaryRelatedInformationUserForm.value.fuelAllowancePm,
        function: null,
        gender: this.generalInformationUserForm.value.gender,
        grade: this.employeementRelatedUserForm.value.grade,
        grossSalaryPm: this.salaryRelatedInformationUserForm.value.grossSalaryPm,
        groupName: this.employeementRelatedUserForm.value.groupName,
        highestEducationInstitute: this.educationRelatedInformationUserForm.value.highestEducationInstitute,
        highestEducationInstitute2: this.educationRelatedInformationUserForm.value.highestEducationInstitute2,
        highestEducationInstitute3: this.educationRelatedInformationUserForm.value.highestEducationInstitute3,
        highestEducationMarks: this.educationRelatedInformationUserForm.value.highestEducationMarks,
        highestEducationMarks2: this.educationRelatedInformationUserForm.value.highestEducationMarks2,
        highestEducationMarks3: this.educationRelatedInformationUserForm.value.highestEducationMarks3,
        highestEducationQualification: this.educationRelatedInformationUserForm.value.highestEducationQualification,
        highestEducationQualification2: this.educationRelatedInformationUserForm.value.highestEducationQualification2,
        highestEducationQualification3: this.educationRelatedInformationUserForm.value.highestEducationQualification3,
        highestEducationYearOfPassing: this.educationRelatedInformationUserForm.value.highestEducationYearOfPassing,
        highestEducationYearOfPassing2: this.educationRelatedInformationUserForm.value.highestEducationYearOfPassing2,
        highestEducationYearOfPassing3: this.educationRelatedInformationUserForm.value.highestEducationYearOfPassing3,
        highestProfessionalInstitute: this.educationRelatedInformationUserForm.value.highestProfessionalInstitute,
        highestProfessionalMarks: this.educationRelatedInformationUserForm.value.highestProfessionalMarks,
        highestProfessionalQualification: this.educationRelatedInformationUserForm.value.highestProfessionalQualification,
        highestProfessionalYearOfPassing: this.educationRelatedInformationUserForm.value.highestProfessionalYearOfPassing,
        hodCode: this.employeementRelatedUserForm.value.hodCode,
        hodName: this.employeementRelatedUserForm.value.hodName,
        hraPm: this.salaryRelatedInformationUserForm.value.hraPm,
        id: this.generalInformationUserForm.value.id,
        ifscCode: this.salaryRelatedInformationUserForm.value.ifscCode,
        incrementOn: this.salaryRelatedInformationUserForm.value.incrementOn,
        isRelativeWorking: this.generalInformationUserForm.value.isRelativeWorking,
        isReplacement: this.generalInformationUserForm.value.isReplacement,
        isVacant: this.employeementRelatedUserForm.value.isVacant,
        lastName: this.generalInformationUserForm.value.lastName,
        lastOrganisationDepartment: this.priorEmploymentRelatedInformationUserForm.value.lastOrganisationDepartment,
        lastOrganisationDesignation: this.priorEmploymentRelatedInformationUserForm.value.lastOrganisationDesignation,
        lastOrganisationDoj: this.datePipe.transform(this.priorEmploymentRelatedInformationUserForm.value.lastOrganisationDoj, "yyyy-MM-dd"),
        lastOrganisationLwd: this.datePipe.transform(this.priorEmploymentRelatedInformationUserForm.value.lastOrganisationLwd, "yyyy-MM-dd"),
        lastOrganisationName: this.priorEmploymentRelatedInformationUserForm.value.lastOrganisationName,
        lastToLastOrganisationDepartment: this.priorEmploymentRelatedInformationUserForm.value.lastToLastOrganisationDepartment,
        lastToLastOrganisationDesignation: this.priorEmploymentRelatedInformationUserForm.value.lastToLastOrganisationDesignation,
        lastToLastOrganisationDoj: this.datePipe.transform(this.priorEmploymentRelatedInformationUserForm.value.lastToLastOrganisationDoj, "yyyy-MM-dd"),
        lastToLastOrganisationLwd: this.datePipe.transform(this.priorEmploymentRelatedInformationUserForm.value.lastToLastOrganisationLwd, "yyyy-MM-dd"),
        lastToLastOrganisationName: this.priorEmploymentRelatedInformationUserForm.value.lastToLastOrganisationName,
        lastWorkingDate: this.datePipe.transform(this.employeementRelatedUserForm.value.lastWorkingDate, "yyyy-MM-dd"),
        lastYearPerformanceRating: this.employeementRelatedUserForm.value.lastYearPerformanceRating,
        lastYearPerformanceScore: this.employeementRelatedUserForm.value.lastYearPerformanceScore,
        ltaPm: this.salaryRelatedInformationUserForm.value.ltaPm,
        lwfPm: this.salaryRelatedInformationUserForm.value.lwfPm,
        maritalStatus: this.generalInformationUserForm.value.maritalStatus,
        medicalAllowancePm: this.salaryRelatedInformationUserForm.value.medicalAllowancePm,
        monthlyCTC: this.salaryRelatedInformationUserForm.value.monthlyCTC,
        mothersName: this.generalInformationUserForm.value.mothersName,
        noOfChildren: this.generalInformationUserForm.value.noOfChildren,
        noOfPromotions: this.employeementRelatedUserForm.value.noOfPromotions,
        officeLocation: this.employeementRelatedUserForm.value.workLocationCity,
        officialEmail: this.employeementRelatedUserForm.value.officialEmail,
        otherAllowancePm: this.salaryRelatedInformationUserForm.value.otherAllowancePm,
        otherOrganisationDepartment: this.priorEmploymentRelatedInformationUserForm.value.otherOrganisationDepartment,
        otherOrganisationDesignation: this.priorEmploymentRelatedInformationUserForm.value.otherOrganisationDesignation,
        otherOrganisationDoj: this.datePipe.transform(this.priorEmploymentRelatedInformationUserForm.value.otherOrganisationDoj, "yyyy-MM-dd"),
        otherOrganisationLwd: this.datePipe.transform(this.priorEmploymentRelatedInformationUserForm.value.otherOrganisationLwd, "yyyy-MM-dd"),
        otherOrganisationName: this.priorEmploymentRelatedInformationUserForm.value.otherOrganisationName,
        otherRetiralPm: this.salaryRelatedInformationUserForm.value.otherRetiralPm,
        panNo: this.generalInformationUserForm.value.panNo,
        permanentAddress: this.generalInformationUserForm.value.permanentAddress,
        personalEmail: this.generalInformationUserForm.value.personalEmail,
        processOfVp: this.salaryRelatedInformationUserForm.value.processOfVp,
        ptPm: this.salaryRelatedInformationUserForm.value.ptPm,
        qualification: null,
        replacementId: this.generalInformationUserForm.value.replacementId,
        reportingManagerCode: this.employeementRelatedUserForm.value.reportingManagerCode,
        reportingManagerName: this.employeementRelatedUserForm.value.reportingManagerName,
        retirementAge: this.employeementRelatedUserForm.value.retirementAge,
        salaryStatus: this.salaryRelatedInformationUserForm.value.salaryStatus,
        salutation: this.generalInformationUserForm.value.salutation,
        specialAllowancePm: this.salaryRelatedInformationUserForm.value.specialAllowancePm,
        spouseName: this.generalInformationUserForm.value.spouseName,
        statutoryBonusPm: this.salaryRelatedInformationUserForm.value.statutoryBonusPm,
        subDepartment: this.employeementRelatedUserForm.value.subDepartment,
        temporaryEmpId: this.employeementRelatedUserForm.value.temporaryEmpId,
        totalExperience: this.generalInformationUserForm.value.totalExperience,
        totalRetiralPm: this.salaryRelatedInformationUserForm.value.totalRetiralPm,
        uan: this.generalInformationUserForm.value.uan,
        washingAllowancePm: this.salaryRelatedInformationUserForm.value.washingAllowancePm,
        workLocationCity: this.employeementRelatedUserForm.value.workLocationCity,
        workLocationState: this.employeementRelatedUserForm.value.workLocationState,
        workingRelativeName: this.generalInformationUserForm.value.workingRelativeName,
        workingRelativeRelation: this.generalInformationUserForm.value.workingRelativeRelation,
        yearBeforeLastYearPerformanceRating: this.employeementRelatedUserForm.value.yearBeforeLastYearPerformanceRating,
        yearBeforeLastYearPerformanceScore: this.employeementRelatedUserForm.value.yearBeforeLastYearPerformanceScore



        // aadharNo: this.userForm.value.aadharNo,
        // address: this.userForm.value.address,
        // annualCTC: this.userForm.value.annualCTC,
        // band: this.userForm.value.band,
        // compId: this.userForm.value.compId,
        // companyName: this.userForm.value.companyName,
        // contactNo: this.userForm.value.contactNo,
        // dateOfBirth: this.datePipe.transform(this.userForm.value.dateOfBirth, "yyyy-MM-dd"),
        // dateOfJoining: this.datePipe.transform(this.userForm.value.dateOfJoining, "yyyy-MM-dd"),
        // dateOfResignation: this.datePipe.transform(this.userForm.value.dateOfResignation, "yyyy-MM-dd"),
        // department: this.userForm.value.department,
        // designation: this.userForm.value.designation,
        // dottedReportingManagerCode: this.userForm.value.dottedReportingManagerCode,
        // dottedReportingManagerName: this.userForm.value.dottedReportingManagerName,
        // emergencyContactNo: this.userForm.value.emergencyContactNo,
        // empCode: this.userForm.value.empCode,
        // empStatus: this.userForm.value.empStatus,
        // firstName: this.userForm.value.firstName,
        // function: this.userForm.value.function,
        // gender: this.userForm.value.gender,
        // grade: this.userForm.value.grade,
        // hodCode: this.userForm.value.hodCode,
        // hodName: this.userForm.value.hodName,
        // id: this.userForm.value.id,
        // isVacant: this.userForm.value.isVacant,
        // lastName: this.userForm.value.lastName,
        // lastWorkingDate: this.datePipe.transform(this.userForm.value.lastWorkingDate, "yyyy-MM-dd"),
        // maritalStatus: this.userForm.value.maritalStatus,
        // monthlyCTC: this.userForm.value.monthlyCTC,
        // officeLocation: this.userForm.value.officeLocation,
        // officialEmail: this.userForm.value.officialEmail,
        // personalEmail: this.userForm.value.personalEmail,
        // qualification: this.userForm.value.qualification,
        // replacementId: this.userForm.value.replacementId,
        // reportingManagerCode: this.userForm.value.reportingManagerCode,
        // reportingManagerName: this.userForm.value.reportingManagerName,
        // totalExperience: this.userForm.value.totalExperience,
        // uan: this.userForm.value.uan
      }
      this.loader.simpleLoaderWithDuration();
      this.httpService.callPostService(this.config.addEmployeeMaster, request)
        .subscribe((data: any) => {
          this.loader.dismissLoader();
          if (!data?.success) {
            this.dataRefreshService.triggerRefresh();

            const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: '30%',
              data: {
                msg: data.data,
                btn2: 'OK',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: false,
                showSuccessMessage: false,
                showCloseIcon: false
              },
            });
            successdialogRef.afterClosed().subscribe(result => {
            });
          } else {
            
            this.loader.dismissLoader();
            if (this.employeementRelatedUserForm.value.empStatus == 'Exited' && this.replacementNotAvailable && !this.isEmployeeRole ) {
              this.assignTempReplacement();
            }
            this.loader.dismissLoader();
            const successdialogRef = this.dialog.open(ConfirmationPopupComponent, {
              disableClose: true,
              height: '25%',
              width: '30%',
              data: {
                msg: data.data,
                btn2: 'OK',
                btn2BgColor: this.buttonColorName,
                showSuccessIcon: true,
                showSuccessMessage: false,
                showCloseIcon: false
              },
            });
            successdialogRef.afterClosed().subscribe(result => {
              this.router.navigate(['/home/hrportal/employeemaster']);
            });
          }
        }, (error: any) => {
        }, () => { });
    }
  }
  getUserByID() {
    this.httpService.callGetService(this.config.getEmployeeById + this.getUserId).subscribe((data: any) => {
      this.employeeData = [];
      this.isFirstEmployee = data?.data?.role?.some((ele: any) => ele.displayName == 'MD');
      this.empCode = data?.data?.empCode;
      this.employeeData.push(data?.data);
      if(data?.data?.role?.length==1){
        if(data?.data?.role[0].displayName == 'Employee'){
          this.isEmployeeRole = true;
        }else{
          this.isEmployeeRole = false;
        }
      }
      this.generalInformationUserForm.controls['aadharNo'].setValue(data?.data?.aadharNo);
      this.generalInformationUserForm.controls['address'].setValue(data?.data?.address);
      this.generalInformationUserForm.controls['age'].setValue(data?.data?.age);
      this.salaryRelatedInformationUserForm.controls['annualCTC'].setValue(data?.data?.annualCtc);
      this.salaryRelatedInformationUserForm.controls['annualTotalCtc'].setValue(data?.data?.annualTotalCtc);
      this.salaryRelatedInformationUserForm.controls['annualVariablePayBudget'].setValue(data?.data?.annualVariablePayBudget);
      this.salaryRelatedInformationUserForm.controls['anyOtherAllowancePm'].setValue(data?.data?.anyOtherAllowancePm);
      this.employeementRelatedUserForm.controls['band'].setValue(data?.data?.band);
      this.salaryRelatedInformationUserForm.controls['bankAccount'].setValue(data?.data?.bankAccount);
      this.salaryRelatedInformationUserForm.controls['bankBranchAddress'].setValue(data?.data?.bankBranchAddress);
      this.salaryRelatedInformationUserForm.controls['bankName'].setValue(data?.data?.bankName);
      this.salaryRelatedInformationUserForm.controls['basicSalaryPm'].setValue(data?.data?.basicSalaryPm);
      this.generalInformationUserForm.controls['bloodGroup'].setValue(data?.data?.bloodGroup);
      this.salaryRelatedInformationUserForm.controls['booksAllowancePm'].setValue(data?.data?.booksAllowancePm);
      this.employeementRelatedUserForm.controls['catalystRole'].setValue(data?.data?.catalystRole);
      this.employeementRelatedUserForm.controls['companyName'].setValue(data?.data?.companyName);
      this.generalInformationUserForm.controls['contactNo'].setValue(data?.data?.contactNo);
      this.generalInformationUserForm.controls['country'].setValue(data?.data?.country);
      this.salaryRelatedInformationUserForm.controls['currency'].setValue(data?.data?.currency);
      this.employeementRelatedUserForm.controls['currentPerformanceRating'].setValue(data?.data?.currentPerformanceRating);
      this.employeementRelatedUserForm.controls['currentPerformanceScore'].setValue(data?.data?.currentPerformanceScore);
      this.salaryRelatedInformationUserForm.controls['daPm'].setValue(data?.data?.daPm);
      this.generalInformationUserForm.controls['dateOfBirth'].setValue(data?.data?.dateOfBirth);
      this.employeementRelatedUserForm.controls['dateOfJoining'].setValue(data?.data?.dateOfJoining);
      this.generalInformationUserForm.controls['dateOfMarriage'].setValue(data?.data?.dateOfMarriage);
      this.employeementRelatedUserForm.controls['dateOfResignation'].setValue(data?.data?.dateOfResignation);
      this.employeementRelatedUserForm.controls['department'].setValue(data?.data?.department);
      this.employeementRelatedUserForm.controls['designation'].setValue(data?.data?.designation);
      this.employeementRelatedUserForm.controls['designationAtDoj'].setValue(data?.data?.designationAtDoj);
      this.employeementRelatedUserForm.controls['dottedReportingManagerCode'].setValue(data?.data?.dottedReportingManager?.employeeId);
      this.employeementRelatedUserForm.controls['dottedReportingManagerName'].setValue(data?.data?.dottedReportingManager?.id);
      this.salaryRelatedInformationUserForm.controls['educationAllowancePm'].setValue(data?.data?.educationAllowancePm);
      this.generalInformationUserForm.controls['emergencyContactNo'].setValue(data?.data?.emergencyContactNo);
      this.employeementRelatedUserForm.controls['empCode'].setValue(data?.data?.empCode);
      this.employeementRelatedUserForm.controls['empStatus'].setValue(data?.data?.empStatus);
      this.salaryRelatedInformationUserForm.controls['employeePfPm'].setValue(data?.data?.employeePfPm);
      this.salaryRelatedInformationUserForm.controls['employerPfPm'].setValue(data?.data?.employerPfPm);
      this.employeementRelatedUserForm.controls['employmentCategory'].setValue(data?.data?.employmentCategory);
      this.employeementRelatedUserForm.controls['employmentType'].setValue(data?.data?.employmentType);
      this.salaryRelatedInformationUserForm.controls['entertainmentAllowancePm'].setValue(data?.data?.entertainmentAllowancePm);
      this.salaryRelatedInformationUserForm.controls['esicPm'].setValue(data?.data?.esicPm);
      this.generalInformationUserForm.controls['fathersName'].setValue(data?.data?.fathersName);
      this.generalInformationUserForm.controls['firstName'].setValue(data?.data?.firstName);
      this.salaryRelatedInformationUserForm.controls['fuelAllowancePm'].setValue(data?.data?.fuelAllowancePm);
      this.generalInformationUserForm.controls['gender'].setValue(data?.data?.gender);
      this.employeementRelatedUserForm.controls['grade'].setValue(data?.data?.grade);
      this.salaryRelatedInformationUserForm.controls['grossSalaryPm'].setValue(data?.data?.grossSalaryPm);
      this.employeementRelatedUserForm.controls['groupName'].setValue(data?.data?.groupName);
      this.educationRelatedInformationUserForm.controls['highestEducationInstitute'].setValue(data?.data?.highestEducationInstitute);
      this.educationRelatedInformationUserForm.controls['highestEducationInstitute2'].setValue(data?.data?.highestEducationInstitute2);
      this.educationRelatedInformationUserForm.controls['highestEducationInstitute3'].setValue(data?.data?.highestEducationInstitute3);
      this.educationRelatedInformationUserForm.controls['highestEducationMarks'].setValue(data?.data?.highestEducationMarks);
      this.educationRelatedInformationUserForm.controls['highestEducationMarks2'].setValue(data?.data?.highestEducationMarks2);
      this.educationRelatedInformationUserForm.controls['highestEducationMarks3'].setValue(data?.data?.highestEducationMarks3);
      this.educationRelatedInformationUserForm.controls['highestEducationQualification'].setValue(data?.data?.highestEducationQualification);
      this.educationRelatedInformationUserForm.controls['highestEducationQualification2'].setValue(data?.data?.highestEducationQualification2);
      this.educationRelatedInformationUserForm.controls['highestEducationQualification3'].setValue(data?.data?.highestEducationQualification3);
      this.educationRelatedInformationUserForm.controls['highestEducationYearOfPassing'].setValue(data?.data?.highestEducationYearOfPassing);
      this.educationRelatedInformationUserForm.controls['highestEducationYearOfPassing2'].setValue(data?.data?.highestEducationYearOfPassing2);
      this.educationRelatedInformationUserForm.controls['highestEducationYearOfPassing3'].setValue(data?.data?.highestEducationYearOfPassing3);
      this.educationRelatedInformationUserForm.controls['highestProfessionalInstitute'].setValue(data?.data?.highestProfessionalInstitute);
      this.educationRelatedInformationUserForm.controls['highestProfessionalMarks'].setValue(data?.data?.highestProfessionalMarks);
      this.educationRelatedInformationUserForm.controls['highestProfessionalQualification'].setValue(data?.data?.highestProfessionalQualification);
      this.educationRelatedInformationUserForm.controls['highestProfessionalYearOfPassing'].setValue(data?.data?.highestProfessionalYearOfPassing);
      this.employeementRelatedUserForm.controls['hodCode'].setValue(data?.data?.hod?.employeeId);
      this.employeementRelatedUserForm.controls['hodName'].setValue(data?.data?.hod?.id);
      this.salaryRelatedInformationUserForm.controls['hraPm'].setValue(data?.data?.hraPm);
      this.generalInformationUserForm.controls['id'].setValue(data?.data?.id);
      this.salaryRelatedInformationUserForm.controls['ifscCode'].setValue(data?.data?.ifscCode);
      this.salaryRelatedInformationUserForm.controls['incrementOn'].setValue(data?.data?.incrementOn);
      this.generalInformationUserForm.controls['isRelativeWorking'].setValue(data?.data?.isRelativeWorking);
      this.generalInformationUserForm.controls['isReplacement'].setValue(data?.data?.isReplacement);
      this.employeementRelatedUserForm.controls['isVacant'].setValue(data?.data?.isVacant);
      this.generalInformationUserForm.controls['lastName'].setValue(data?.data?.lastName);
      this.priorEmploymentRelatedInformationUserForm.controls['lastOrganisationDepartment'].setValue(data?.data?.lastOrganisationDepartment);
      this.priorEmploymentRelatedInformationUserForm.controls['lastOrganisationDesignation'].setValue(data?.data?.lastOrganisationDesignation);
      this.priorEmploymentRelatedInformationUserForm.controls['lastOrganisationDoj'].setValue(data?.data?.lastOrganisationDoj);
      this.priorEmploymentRelatedInformationUserForm.controls['lastOrganisationLwd'].setValue(data?.data?.lastOrganisationLwd);
      this.priorEmploymentRelatedInformationUserForm.controls['lastOrganisationName'].setValue(data?.data?.lastOrganisationName);
      this.priorEmploymentRelatedInformationUserForm.controls['lastToLastOrganisationDepartment'].setValue(data?.data?.lastToLastOrganisationDepartment);
      this.priorEmploymentRelatedInformationUserForm.controls['lastToLastOrganisationDesignation'].setValue(data?.data?.lastToLastOrganisationDesignation);
      this.priorEmploymentRelatedInformationUserForm.controls['lastToLastOrganisationDoj'].setValue(data?.data?.lastToLastOrganisationDoj);
      this.priorEmploymentRelatedInformationUserForm.controls['lastToLastOrganisationLwd'].setValue(data?.data?.lastToLastOrganisationLwd);
      this.priorEmploymentRelatedInformationUserForm.controls['lastToLastOrganisationName'].setValue(data?.data?.lastToLastOrganisationName);
      this.employeementRelatedUserForm.controls['lastWorkingDate'].setValue(data?.data?.lastWorkingDate);
      this.employeementRelatedUserForm.controls['lastYearPerformanceRating'].setValue(data?.data?.lastYearPerformanceRating);
      this.employeementRelatedUserForm.controls['lastYearPerformanceScore'].setValue(data?.data?.lastYearPerformanceScore);
      this.salaryRelatedInformationUserForm.controls['ltaPm'].setValue(data?.data?.ltaPm);
      this.salaryRelatedInformationUserForm.controls['lwfPm'].setValue(data?.data?.lwfPm);
      this.generalInformationUserForm.controls['maritalStatus'].setValue(data?.data?.maritalStatus);
      this.salaryRelatedInformationUserForm.controls['medicalAllowancePm'].setValue(data?.data?.medicalAllowancePm);
      this.salaryRelatedInformationUserForm.controls['monthlyCTC'].setValue(data?.data?.monthlyCtc);
      this.generalInformationUserForm.controls['mothersName'].setValue(data?.data?.mothersName);
      this.generalInformationUserForm.controls['noOfChildren'].setValue(data?.data?.noOfChildren);
      this.employeementRelatedUserForm.controls['noOfPromotions'].setValue(data?.data?.noOfPromotions);
      this.employeementRelatedUserForm.controls['workLocationCity'].setValue(data?.data?.workLocationCity);
      this.employeementRelatedUserForm.controls['officialEmail'].setValue(data?.data?.officialEmail);
      this.salaryRelatedInformationUserForm.controls['otherAllowancePm'].setValue(data?.data?.otherAllowancePm);
      this.priorEmploymentRelatedInformationUserForm.controls['otherOrganisationDepartment'].setValue(data?.data?.otherOrganisationDepartment);
      this.priorEmploymentRelatedInformationUserForm.controls['otherOrganisationDesignation'].setValue(data?.data?.otherOrganisationDesignation);
      this.priorEmploymentRelatedInformationUserForm.controls['otherOrganisationDoj'].setValue(data?.data?.otherOrganisationDoj);
      this.priorEmploymentRelatedInformationUserForm.controls['otherOrganisationLwd'].setValue(data?.data?.otherOrganisationLwd);
      this.priorEmploymentRelatedInformationUserForm.controls['otherOrganisationName'].setValue(data?.data?.otherOrganisationName);
      this.salaryRelatedInformationUserForm.controls['otherRetiralPm'].setValue(data?.data?.otherRetiralPm);
      this.generalInformationUserForm.controls['panNo'].setValue(data?.data?.panNo);
      this.generalInformationUserForm.controls['permanentAddress'].setValue(data?.data?.permanentAddress);
      this.generalInformationUserForm.controls['personalEmail'].setValue(data?.data?.email);
      this.salaryRelatedInformationUserForm.controls['processOfVp'].setValue(data?.data?.processOfVp);
      this.salaryRelatedInformationUserForm.controls['ptPm'].setValue(data?.data?.ptPm);
      this.generalInformationUserForm.controls['replacementId'].setValue(data?.data?.replacementId);
      this.employeementRelatedUserForm.controls['reportingManagerCode'].setValue(data?.data?.reportingManager?.employeeId);
      this.employeementRelatedUserForm.controls['reportingManagerName'].setValue(data?.data?.reportingManager?.id);
      this.employeementRelatedUserForm.controls['retirementAge'].setValue(data?.data?.retirementAge);
      this.salaryRelatedInformationUserForm.controls['salaryStatus'].setValue(data?.data?.salaryStatus);
      this.generalInformationUserForm.controls['salutation'].setValue(data?.data?.salutation);
      this.salaryRelatedInformationUserForm.controls['specialAllowancePm'].setValue(data?.data?.specialAllowancePm);
      this.generalInformationUserForm.controls['spouseName'].setValue(data?.data?.spouseName);
      this.salaryRelatedInformationUserForm.controls['statutoryBonusPm'].setValue(data?.data?.statutoryBonusPm);
      this.employeementRelatedUserForm.controls['subDepartment'].setValue(data?.data?.subDepartment);
      this.employeementRelatedUserForm.controls['temporaryEmpId'].setValue(data?.data?.temporaryEmpId);
      this.generalInformationUserForm.controls['totalExperience'].setValue(data?.data?.totalExperience);
      this.salaryRelatedInformationUserForm.controls['totalRetiralPm'].setValue(data?.data?.totalRetiralPm);
      this.generalInformationUserForm.controls['uan'].setValue(data?.data?.uan);
      this.salaryRelatedInformationUserForm.controls['washingAllowancePm'].setValue(data?.data?.washingAllowancePm);
      this.employeementRelatedUserForm.controls['workLocationCity'].setValue(data?.data?.workLocationCity);
      this.employeementRelatedUserForm.controls['workLocationState'].setValue(data?.data?.workLocationState);
      this.generalInformationUserForm.controls['workingRelativeName'].setValue(data?.data?.workingRelativeName);
      this.generalInformationUserForm.controls['workingRelativeRelation'].setValue(data?.data?.workingRelativeRelation);
      this.employeementRelatedUserForm.controls['yearBeforeLastYearPerformanceRating'].setValue(data?.data?.yearBeforeLastYearPerformanceRating);
      this.employeementRelatedUserForm.controls['yearBeforeLastYearPerformanceScore'].setValue(data?.data?.yearBeforeLastYearPerformanceScore);

      this.officialEmail = data?.data?.officialEmail;
      this.uan = data?.data?.uan;
      this.panNo = data?.data?.panNo;
      this.bankAccount = data?.data?.bankAccount;
      this.aadharNo = data?.data?.aadharNo;
      for(let i=0; i<this.customFieldObject.length;i++){
        for(let j=0; j<data?.data?.customValues.length;j++){
          if(this.customFieldObject[i].fieldId == data?.data?.customValues[j].fieldId){
            this.customFieldObject[i].fieldName = data?.data?.customValues[j].fieldName,
            this.customFieldObject[i].fieldValue = data?.data?.customValues[j].fieldValue,
            this.customFieldObject[i].id= data?.data?.customValues[j].id
          }
        }
      }
      if(data?.data?.empStatus == 'Exited'){
        this.checkUanNo();
        this.checkAccountNo();
        this.checkPanNo();
        this.checkAadharNo();
        this.checkEmailInTheSystem();
        this.checkEmpCode();
      }
      // this.userForm.controls['aadharNo'].setValue(data?.data?.aadharNo);
      // this.userForm.controls['address'].setValue(data?.data?.address);
      // this.userForm.controls['annualCTC'].setValue(data?.data?.annualCtc);
      // this.userForm.controls['band'].setValue(data?.data?.band);
      // this.userForm.controls['compId'].setValue(data?.data?.companyId);
      // this.userForm.controls['companyName'].setValue(data?.data?.companyName);
      // this.userForm.controls['contactNo'].setValue(data?.data?.contactNo);
      // this.userForm.controls['dateOfBirth'].setValue(data?.data?.dateOfBirth);
      // this.userForm.controls['dateOfJoining'].setValue(data?.data?.dateOfJoining);
      // this.userForm.controls['dateOfResignation'].setValue(data?.data?.dateOfResignation);
      // this.userForm.controls['department'].setValue(data?.data?.department);
      // this.userForm.controls['designation'].setValue(data?.data?.designation);
      // this.userForm.controls['dottedReportingManagerCode'].setValue(data?.data?.dottedReportingManagerCode);
      // this.userForm.controls['dottedReportingManagerName'].setValue(data?.data?.dottedReportingManager?.id);
      // this.userForm.controls['emergencyContactNo'].setValue(data?.data?.emergencyContactNo);
      // this.userForm.controls['empCode'].setValue(data?.data?.empCode);
      // this.userForm.controls['empStatus'].setValue(data?.data?.empStatus);
      // this.userForm.controls['firstName'].setValue(data?.data?.firstName);
      // this.userForm.controls['function'].setValue(data?.data?.empFunction);
      // this.userForm.controls['gender'].setValue(data?.data?.gender);
      // this.userForm.controls['grade'].setValue(data?.data?.grade);
      // this.userForm.controls['hodCode'].setValue(data?.data?.hodCode);
      // this.userForm.controls['hodName'].setValue(data?.data?.hod?.id);
      // this.userForm.controls['id'].setValue(data?.data?.id);
      // this.userForm.controls['isVacant'].setValue(data?.data?.isVacant);
      // this.userForm.controls['lastName'].setValue(data?.data?.lastName);
      // this.userForm.controls['lastWorkingDate'].setValue(data?.data?.lastWorkingDate);
      // this.userForm.controls['maritalStatus'].setValue(data?.data?.maritalStatus);
      // this.userForm.controls['monthlyCTC'].setValue(data?.data?.monthlyCtc);
      // this.userForm.controls['officeLocation'].setValue(data?.data?.location);
      // this.userForm.controls['officialEmail'].setValue(data?.data?.officialEmail);
      // this.userForm.controls['personalEmail'].setValue(data?.data?.email);
      // this.userForm.controls['qualification'].setValue(data?.data?.qualification);
      // this.userForm.controls['replacementId'].setValue(data?.data?.replacementId);
      // this.userForm.controls['reportingManagerCode'].setValue(data?.data?.reportingManagerCode);
      // this.userForm.controls['reportingManagerName'].setValue(data?.data?.reportingManager?.id);
      // this.userForm.controls['totalExperience'].setValue(data?.data?.totalExperience);
      // this.userForm.controls['uan'].setValue(data?.data?.uan);
    })
  }
  assignReporteesDropdown: any = [];
  getAllEmployeeDropdownByCompanyID() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
    }
    this.httpService.callPostService(this.config.getAllEmployeeDropdownByCompanyID, request)
      .subscribe((data: any) => {
        this.getAllEmployeeofCompany = [];
        this.assignReporteesDropdown = [];
        data?.data?.users.forEach((ele: any) => {
          if (this.getUserId != ele.id) {
            let obj = {
              id: ele.id,
              name: ele.firstName + ' ' + ele.lastName,
              empCode: ele.empCode
            }
            this.assignReporteesDropdown.push(obj);
          }
        });
        data?.data?.users.forEach((ele: any) => {
          let obj = {
            id: ele.id,
            name: ele.firstName + ' ' + ele.lastName,
            empCode: ele.empCode
          }
          this.getAllEmployeeofCompany.push(obj);
        });
        if (this.getAllEmployeeofCompany.length < 1) {
          this.isFirstEmployee = true;
          this.getCompanyDataByCompID()
        }
      }, (error: any) => {
      }, () => { });
  }
  gotToImport() {
    this.router.navigate(['/home/hrportal/importFiles', { module: 'importemployee' }]);
  }
  transform(value: string): string {
    switch (value) {
      case 'OnBoardingPending':
        return 'On-Boarding Pending';
      case 'Active':
        return 'Active';
      case 'Inactive':
        return 'Inactive';
      case 'Jan_Dec':
        return 'Jan-Dec';
      case 'Apr_Mar':
        return 'Apr-Mar';
      case 'July_Jun':
        return 'July-Jun';
      case 'Oct_Sep':
        return 'Oct-Sep';
      default:
        return value;
    }
  }
  editEmployeeData() {
    this.router.navigate(['/home/hrportal/employeemaster', { id: this.getUserId, operation: 'Edit' }]);
  }
  onSelectionOfHod() {
    var data = this.assignReporteesDropdown.find((item: { id: any; }) => item.id === this.employeementRelatedUserForm.controls['hodName'].value);
    this.employeementRelatedUserForm.controls['hodCode'].setValue(data?.empCode);
  }
  onSelectionOfManager() {
    var data = this.assignReporteesDropdown.find((item: { id: any; }) => item.id === this.employeementRelatedUserForm.controls['reportingManagerName'].value);
    this.employeementRelatedUserForm.controls['reportingManagerCode'].setValue(data?.empCode);
  }
  onSelectionOfDottedManager() {
    var data = this.assignReporteesDropdown.find((item: { id: any; }) => item.id === this.employeementRelatedUserForm.controls['dottedReportingManagerName'].value);
    this.employeementRelatedUserForm.controls['dottedReportingManagerCode'].setValue(data?.empCode);
  }
  onClickEmployeeReplacement() {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.height = '70%';
    dialogConfig.width = '100%';
    dialogConfig.data = { compId: this.loggedInUserCompanyID, userId: this.generalInformationUserForm.value.id };
    dialogConfig.panelClass = 'custom-dialog-container';
    const dialogRef = this.dialog.open(ReplaceEmployeePopupComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      this.isReplaceEmployeeFilled = result;
    });
  }
  getEmployeeCount() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "loggedInUserRole": this.loggedInUserRole,
    }
    this.loader.simpleLoaderWithDuration();
    this.httpService.callPostService(this.config.getEmployeeCount, request)
      .subscribe((data: any) => {
        this.gridData.tabsData = [
          { label: 'Active', totalCount: data.data?.activeNo, icons: 'person' },
          { label: 'Exited', totalCount: data.data?.exitedNo, icons: 'person_off' },
        ]
      }, (error: any) => {
        this.loader.dismissLoader();
      }, () => { });
  }
  changeSubMenuBackgroundColor(): void {
    const activeTab = document.getElementsByClassName('mdc-tab--active')[0];
    (activeTab as HTMLElement).style.backgroundColor = this.subModuleButtonColor;
    (activeTab as HTMLElement).classList.add('active-tab');
  }
  removeSubMenuPreviousActiveTabClass(): void {
    const previousActiveTab = document.getElementsByClassName('active-tab')[0];
    (previousActiveTab as HTMLElement).style.backgroundColor = '#E5E5E5';
    previousActiveTab.classList.remove('active-tab');
  }
  changeEmployeeStatus(value: any) {
    if (value == 'Exited') {
      const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
        disableClose: true,
        height: '25%',
        width: '30%',
        data: {
          msg: 'Is replacement available?',
          btn1: 'No',
          btn2: 'Yes',
          btn2BgColor: this.buttonColorName,
          showSuccessIcon: false,
          showSuccessMessage: false,
          showCloseIcon: false
        },
      });
      dialogRef.afterClosed().subscribe(result => {
        
        if (result) {
          this.generalInformationUserForm.controls['isReplacement'].setValue(true);
          this.replacementNotAvailable = false;
        } else {
          this.generalInformationUserForm.controls['isReplacement'].setValue(false);
          this.replacementNotAvailable = true;
        }
      });
    } else {
      this.employeementRelatedUserForm.controls['lastWorkingDate'].setValue(null);
      this.employeementRelatedUserForm.controls['dateOfResignation'].setValue(null);
    }
  }
  assignTempReplacement() {
    const request = {
      "compId": this.loggedInUserCompanyID,
      "isReplacement": this.generalInformationUserForm.value.isReplacement,
      "replacementId": this.getUserId,
      "temporaryEmpId": this.employeementRelatedUserForm.value.temporaryEmpId,
    }
    this.httpService.callPostService(this.config.replaceEmployee, request)
      .subscribe((data: any) => {
      }, (error: any) => {
      }, () => { });
  }
  getCompanyDataByCompID() {
    this.loader.simpleLoaderWithDuration();
    this.httpService.callGetService(this.config.getCompanyDataByCompID + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.loader.dismissLoader();
      this.employeementRelatedUserForm.controls['empCode'].setValue(data?.data?.employeeIdOfMD);
    })
  }
  onClickLogs(moduleName: any) {
    this.router.navigate(['/home/hrportal/auidtlogs', { moduleName: moduleName, id: this.getUserId, code: this.empCode }]);
  }
  onDateOfResignationChange(event: any) {
    this.employeementRelatedUserForm.controls['lastWorkingDate'].setValue(null)
  }
  calculateAgeFromDOB() {
    const dob = new Date(this.generalInformationUserForm.value.dateOfBirth)
    const today = new Date();
    let age = today.getFullYear() - dob.getFullYear();
    const monthDiff = today.getMonth() - dob.getMonth();

    // Adjust age if the current date is before the birth date in the current year
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
      age--;
    }

    this.generalInformationUserForm.controls['age'].setValue(age);
  }

  getGroupNameByCompany() {
    this.httpService.callGetService(this.config.getGroupNameByCompany + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.getListOfGroupNameOfComp = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.getListOfGroupNameOfComp.push(obj);
      });
      this.getListOfGroupNameOfComp = this.getListOfGroupNameOfComp.sort((a: { name: any; }, b: { name: any; }) => a.name.localeCompare(b.name));
    })
  }
  getCompanyNameByCompany() {
    this.httpService.callGetService(this.config.getCompanyNameByCompany + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.getListOfCompanyNameOfComp = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.getListOfCompanyNameOfComp.push(obj);
      });
      this.getListOfCompanyNameOfComp = this.getListOfCompanyNameOfComp.sort((a: { name: any; }, b: { name: any; }) => a.name.localeCompare(b.name));
    })
  }
  getBandsByCompany() {
    this.httpService.callGetService(this.config.getBandsByCompany + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.getListOfBandNameOfComp = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.getListOfBandNameOfComp.push(obj);
      });
      this.getListOfBandNameOfComp = this.getListOfBandNameOfComp.sort((a: { name: any; }, b: { name: any; }) => a.name.localeCompare(b.name));
    })
  }
  getGradeByCompany() {
    this.httpService.callGetService(this.config.getGradesByCompany + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.getListOfGradeNameOfComp = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.getListOfGradeNameOfComp.push(obj);
      });
      this.getListOfGradeNameOfComp = this.getListOfGradeNameOfComp.sort((a: { name: any; }, b: { name: any; }) => a.name.localeCompare(b.name));
    })
  }
  getDesignationsByCompany() {
    this.httpService.callGetService(this.config.getDesignationsByCompany + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.getListOfDesignationsOfComp = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.getListOfDesignationsOfComp.push(obj);
      });
      this.getListOfDesignationsOfComp = this.getListOfDesignationsOfComp.sort((a: { name: any; }, b: { name: any; }) => a.name.localeCompare(b.name));
    })
  }
  getDepartmentsByCompany() {
    this.httpService.callGetService(this.config.getDepartmentsByCompany + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.getListOfDepartmentsOfComp = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.getListOfDepartmentsOfComp.push(obj);
      });
      this.getListOfDepartmentsOfComp = this.getListOfDepartmentsOfComp.sort((a: { name: any; }, b: { name: any; }) => a.name.localeCompare(b.name));
    })
  }
  getSubDepartmentByCompany() {
    this.httpService.callGetService(this.config.getSubDepartmentByCompany + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.getListOfSubDepartmentsOfComp = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.getListOfSubDepartmentsOfComp.push(obj);
      });
      this.getListOfSubDepartmentsOfComp = this.getListOfSubDepartmentsOfComp.sort((a: { name: any; }, b: { name: any; }) => a.name.localeCompare(b.name));
    })
  }
  getDesignationsAtDOJByCompany() {
    this.httpService.callGetService(this.config.getDesignationsAtDOJByCompany + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.getListOfDesignationsAtDOJOfComp = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.getListOfDesignationsAtDOJOfComp.push(obj);
      });
      this.getListOfDesignationsAtDOJOfComp = this.getListOfDesignationsAtDOJOfComp.sort((a: { name: any; }, b: { name: any; }) => a.name.localeCompare(b.name));
    })
  }
  getCurrentRatingByCompany() {
    this.httpService.callGetService(this.config.getCurrentRatingByCompany + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.getListOfCurrentRatingOfComp = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.getListOfCurrentRatingOfComp.push(obj);
      });
      this.getListOfCurrentRatingOfComp = this.getListOfCurrentRatingOfComp.sort((a: { name: any; }, b: { name: any; }) => a.name.localeCompare(b.name));
    })
  }
  getLastYearRatingByCompany() {
    this.httpService.callGetService(this.config.getLastYearRatingByCompany + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.getListOfLastYearRatingOfComp = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.getListOfLastYearRatingOfComp.push(obj);
      });
      this.getListOfLastYearRatingOfComp = this.getListOfLastYearRatingOfComp.sort((a: { name: any; }, b: { name: any; }) => a.name.localeCompare(b.name));
    })
  }
  getLastToLastYearRatingByCompany() {
    this.httpService.callGetService(this.config.getLastToLastYearRatingByCompany + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.getListOfLastToLastYearRatingOfComp = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.getListOfLastToLastYearRatingOfComp.push(obj);
      });
      this.getListOfLastToLastYearRatingOfComp = this.getListOfLastToLastYearRatingOfComp.sort((a: { name: any; }, b: { name: any; }) => a.name.localeCompare(b.name));
    })
  }
  getAllCountryList() {
    this.httpService.callGetService("https://restcountries.com/v3.1/all").subscribe((data: any) => {
      this.getCountryList = [];
      var getCountryList = data.map((country: { name: { common: any; }; }) => country.name.common);
      getCountryList?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.getCountryList.push(obj);
      });
      this.getCountryList = this.getCountryList.sort((a: { name: any; }, b: { name: any; }) => a.name.localeCompare(b.name));
    })
  }
  getCurrencyByCompany() {
    this.httpService.callGetService(this.config.getCurrencyByCompany + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.getCurrencyList = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.getCurrencyList.push(obj);
      });
      this.getCurrencyList = this.getCurrencyList.sort((a: { name: any; }, b: { name: any; }) => a.name.localeCompare(b.name));
    })
  }
  getBankNameByCompany() {
    this.httpService.callGetService(this.config.getBankNameByCompany + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.getBankNameList = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.getBankNameList.push(obj);
      });
      this.getBankNameList = this.getBankNameList.sort((a: { name: any; }, b: { name: any; }) => a.name.localeCompare(b.name));
    })
  }
  getHighestQualificationByCompany() {
    this.httpService.callGetService(this.config.getHighestQualificationByCompany + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.getListOfHighestQualificationOfComp = [];
      data?.data?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: ele,
        }
        this.getListOfHighestQualificationOfComp.push(obj);
      });
      this.getListOfHighestQualificationOfComp = this.getListOfHighestQualificationOfComp.sort((a: { name: any; }, b: { name: any; }) => a.name.localeCompare(b.name));
    })
  }

  states: string[] = [
    'Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh',
    'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jharkhand', 'Karnataka',
    'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur', 'Meghalaya',
    'Mizoram', 'Nagaland', 'Odisha', 'Punjab', 'Rajasthan', 'Sikkim',
    'Tamil Nadu', 'Telangana', 'Tripura', 'Uttar Pradesh', 'Uttarakhand',
    'West Bengal', 'Andaman and Nicobar Islands', 'Chandigarh',
    'Dadra and Nagar Haveli and Daman and Diu', 'Lakshadweep',
    'Delhi', 'Puducherry', 'Ladakh', 'Jammu and Kashmir'
  ];
  getAllCustomFieldsList() {
    this.httpService.callGetService(this.config.getAllCustomFieldsList).subscribe((data: any) => {
      this.customFieldObject = [];
      data?.objectData?.setResponse?.forEach((ele: any) => {
        let obj = {
          fieldId: ele?.id,
          fieldName: ele.fieldName,
          fieldValue: null,
          id: null
        }
        this.customFieldObject.push(obj);
      });
    })
  }

  checkUanNo() {
    
    if(this.isEditModeactive){
      if(this.uan == this.generalInformationUserForm.value.uan){
        return;
      }
    }
    if(this.generalInformationUserForm.value.uan.toString().length!=12){
      return
    }
    if (this.generalInformationUserForm.value.uan != null) {
      const request = {
        "field": this.generalInformationUserForm.value.uan
      }
      this.httpService.callPostService(this.config.checkUanNo, request)
        .subscribe((data: any) => {
          if (!data?.status) {
            this.showErrorMsgOfExistUAN = true;
          } else {
            this.showErrorMsgOfExistUAN = false;
          }
        }, (error: any) => {
        }, () => { });
    }
  }
  checkAccountNo() {
    
    if(this.isEditModeactive){
      if(this.bankAccount == this.salaryRelatedInformationUserForm.value.bankAccount){
        return;
      }
    }
    if (this.salaryRelatedInformationUserForm.value.bankAccount != null) {
      const request = {
        "field": this.salaryRelatedInformationUserForm.value.bankAccount
      }
      this.httpService.callPostService(this.config.checkAccountNo, request)
        .subscribe((data: any) => {
          if (!data?.status) {
            this.showErrorMsgOfExistAccountNo = true;
          } else {
            this.showErrorMsgOfExistAccountNo = false;
          }
        }, (error: any) => {
        }, () => { });
    }
  }
  checkPanNo() {
    if(this.isEditModeactive){
      if(this.panNo == this.generalInformationUserForm.value.panNo){
        return;
      }
    }
    if(this.generalInformationUserForm.value.panNo.length!=10){
      return
    }
    if (this.generalInformationUserForm.value.panNo != null) {
      const request = {
        "field": this.generalInformationUserForm.value.panNo
      }
      this.httpService.callPostService(this.config.checkPanNo, request)
        .subscribe((data: any) => {
          if (!data?.status) {
            this.showErrorMsgOfExistPAN = true;
          } else {
            this.showErrorMsgOfExistPAN = false;
          }
        }, (error: any) => {
        }, () => { });
    }
  }
  checkAadharNo() {
    if(this.isEditModeactive){
      if(this.aadharNo == this.generalInformationUserForm.value.aadharNo){
        return;
      }
    }
    if(this.generalInformationUserForm.value.aadharNo.toString().length!=12){
      return
    }
    if (this.generalInformationUserForm.value.aadharNo != null) {
      const request = {
        "field": this.generalInformationUserForm.value.aadharNo,
      }
      this.httpService.callPostService(this.config.checkAadharNo, request)
        .subscribe((data: any) => {
          if (!data?.status) {
            this.showErrorMsgOfExistAddharNo = true;
          } else {
            this.showErrorMsgOfExistAddharNo = false;
          }
        }, (error: any) => {
        }, () => { });
    }
  }
  checkEmailInTheSystem() {
    
    if(this.isEditModeactive){
      if(this.officialEmail == this.employeementRelatedUserForm.value.officialEmail){
        return;
      }
    }
    if(this.employeementRelatedUserForm.value.officialEmail==""){
      this.employeementRelatedUserForm.controls['officialEmail'].setValue(null);
    }
    if (this.employeementRelatedUserForm.value.officialEmail != null) {
      const request = {
        "email": this.employeementRelatedUserForm.value.officialEmail,
        "companyId":this.loggedInUserCompanyID
      }
      this.httpService.callPostService(this.config.checkEmailInTheSystem, request)
        .subscribe((data: any) => {
          if (!data?.status) {
            this.showErrorMsgOfExistEmail = true;
          } else {
            this.showErrorMsgOfExistEmail = false;
          }
        }, (error: any) => {
        }, () => { });
    }else{
      this.showErrorMsgOfExistEmail=false;
    }
  }
  checkEmpCode(){
    if(this.isEditModeactive){
      if(this.empCode == this.generalInformationUserForm.value.empCode){
        return;
      }
    }
    if(this.generalInformationUserForm.value.empCode.length!=10){
      return
    }
    if (this.generalInformationUserForm.value.empCode != null) {
      const request = {
        "field": this.generalInformationUserForm.value.empCode,
      }
      this.httpService.callPostService(this.config.checkEmployeeCode, request)
        .subscribe((data: any) => {
          if (!data?.status) {
            this.showErrorMsgOfExistEmpCode = true;
          } else {
            this.showErrorMsgOfExistEmpCode = false;
          }
        }, (error: any) => {
        }, () => { });
    }
  }
  caluclateGrossSalary() {
    // this.salaryRelatedInformationUserForm.controls['basicSalaryPm'].setValue(
    //   this.currencyPipe.transform(this.salaryRelatedInformationUserForm.value.basicSalaryPm,'INR','', '1.2-2'));
    // this.salaryRelatedInformationUserForm.controls['daPm'].setValue(
    //   this.decimalPipe.transform(this.salaryRelatedInformationUserForm.value.daPm));
    // this.salaryRelatedInformationUserForm.controls['hraPm'].setValue(
    //   this.decimalPipe.transform(this.salaryRelatedInformationUserForm.value.hraPm));
    // this.salaryRelatedInformationUserForm.controls['otherAllowancePm'].setValue(
    //   this.decimalPipe.transform(this.salaryRelatedInformationUserForm.value.otherAllowancePm));
    // this.salaryRelatedInformationUserForm.controls['ltaPm'].setValue(
    //   this.decimalPipe.transform(this.salaryRelatedInformationUserForm.value.ltaPm));
    // this.salaryRelatedInformationUserForm.controls['medicalAllowancePm'].setValue(
    //   this.decimalPipe.transform(this.salaryRelatedInformationUserForm.value.medicalAllowancePm));
    // this.salaryRelatedInformationUserForm.controls['washingAllowancePm'].setValue(
    //   this.decimalPipe.transform(this.salaryRelatedInformationUserForm.value.washingAllowancePm));
    // this.salaryRelatedInformationUserForm.controls['specialAllowancePm'].setValue(
    //   this.decimalPipe.transform(this.salaryRelatedInformationUserForm.value.specialAllowancePm));
    // this.salaryRelatedInformationUserForm.controls['fuelAllowancePm'].setValue(
    //   this.decimalPipe.transform(this.salaryRelatedInformationUserForm.value.fuelAllowancePm));
    // this.salaryRelatedInformationUserForm.controls['entertainmentAllowancePm'].setValue(
    //   this.decimalPipe.transform(this.salaryRelatedInformationUserForm.value.entertainmentAllowancePm));
    // this.salaryRelatedInformationUserForm.controls['educationAllowancePm'].setValue(
    //   this.decimalPipe.transform(this.salaryRelatedInformationUserForm.value.educationAllowancePm));
    // this.salaryRelatedInformationUserForm.controls['booksAllowancePm'].setValue(
    //   this.decimalPipe.transform(this.salaryRelatedInformationUserForm.value.booksAllowancePm));
    // this.salaryRelatedInformationUserForm.controls['statutoryBonusPm'].setValue(
    //   this.decimalPipe.transform(this.salaryRelatedInformationUserForm.value.statutoryBonusPm));
    // this.salaryRelatedInformationUserForm.controls['anyOtherAllowancePm'].setValue(
    //   this.decimalPipe.transform(this.salaryRelatedInformationUserForm.value.anyOtherAllowancePm));
    
    const basicSalaryPm = Number(this.salaryRelatedInformationUserForm.value.basicSalaryPm);
    const daPm =  Number(this.salaryRelatedInformationUserForm.value.daPm);
    const hraPm =  Number(this.salaryRelatedInformationUserForm.value.hraPm);
    const otherAllowancePm =  Number(this.salaryRelatedInformationUserForm.value.otherAllowancePm);
    const ltaPm =  Number(this.salaryRelatedInformationUserForm.value.ltaPm);
    const medicalAllowancePm =  Number(this.salaryRelatedInformationUserForm.value.medicalAllowancePm);
    const washingAllowancePm =  Number(this.salaryRelatedInformationUserForm.value.washingAllowancePm);
    const specialAllowancePm =  Number(this.salaryRelatedInformationUserForm.value.specialAllowancePm);
    const fuelAllowancePm =  Number(this.salaryRelatedInformationUserForm.value.fuelAllowancePm);
    const entertainmentAllowancePm =  Number(this.salaryRelatedInformationUserForm.value.entertainmentAllowancePm);
    const educationAllowancePm =  Number(this.salaryRelatedInformationUserForm.value.educationAllowancePm);
    const booksAllowancePm =  Number(this.salaryRelatedInformationUserForm.value.booksAllowancePm);
    const statutoryBonusPm =  Number(this.salaryRelatedInformationUserForm.value.statutoryBonusPm);
    const anyOtherAllowancePm =  Number(this.salaryRelatedInformationUserForm.value.anyOtherAllowancePm);

    this.salaryRelatedInformationUserForm.controls['grossSalaryPm'].setValue(basicSalaryPm + daPm + hraPm + otherAllowancePm +
      ltaPm + medicalAllowancePm + washingAllowancePm + specialAllowancePm + fuelAllowancePm + entertainmentAllowancePm + educationAllowancePm
      + booksAllowancePm + statutoryBonusPm + anyOtherAllowancePm);
    // this.salaryRelatedInformationUserForm.controls['grossSalaryPm'].setValue(
    //   this.decimalPipe.transform(this.salaryRelatedInformationUserForm.value.grossSalaryPm));
  }
  onInputChange(value: any) {
    // const numericValue = value?.replace(/,/g, '');
    // this.salaryRelatedInformationUserForm.controls['basicSalaryPm'].setValue(numericValue, { emitEvent: false });
  }
  caluclateAnnualTotalCTC(){
    const annualCTC = Number(this.salaryRelatedInformationUserForm.value.annualCTC);
    const annualVariablePayBudget = Number(this.salaryRelatedInformationUserForm.value.annualVariablePayBudget);
    this.salaryRelatedInformationUserForm.controls['annualTotalCtc'].setValue(annualCTC + annualVariablePayBudget);
  }
  checkNumerIsPositive(event:any,fomrControlName:any){
    const inputElement = event.target as HTMLInputElement;
    var value = inputElement.value;
    if(Number(value) < 0){
      this.salaryRelatedInformationUserForm.controls[fomrControlName].setValue(null);
    }
  }
  checkNumerIsPositiveemployeementRelatedUserForm(event:any,fomrControlName:any){
    const inputElement = event.target as HTMLInputElement;
    var value = inputElement.value;
    if(Number(value) < 0){
      this.employeementRelatedUserForm.controls[fomrControlName].setValue(null);
    }
  }
  checkNumerIsPositivgeneralInformationUserForm(event:any,fomrControlName:any){
    const inputElement = event.target as HTMLInputElement;
    var value = inputElement.value;
    if(Number(value) < 0){
      this.generalInformationUserForm.controls[fomrControlName].setValue(null);
    }
  }
  checkNumerIsPositiveeducationRelatedInformationUserForm(event:any,fomrControlName:any){
    const inputElement = event.target as HTMLInputElement;
    var value = inputElement.value;
    if(Number(value) < 0){
      this.educationRelatedInformationUserForm.controls[fomrControlName].setValue(null);
    }
  }
}

